export const privacyPolicy = `
<html>

<head>
    <meta content="text/html; charset=UTF-8" http-equiv="content-type">
    <style type="text/css">
        @import url('https://themes.googleusercontent.com/fonts/css?kit=dpiI8CyVsrzWsJLBFKehGpLhv3qFjX7dUn1mYxfCXhI');
        .lst-kix_9c69ktmkhots-4>li {
            counter-increment: lst-ctn-kix_9c69ktmkhots-4
        }

        ol.lst-kix_ofi0mmcnclsi-4.start {
            counter-reset: lst-ctn-kix_ofi0mmcnclsi-4 0
        }

        ol.lst-kix_9c69ktmkhots-2.start {
            counter-reset: lst-ctn-kix_9c69ktmkhots-2 0
        }

        .lst-kix_925qe2elwufe-2>li {
            counter-increment: lst-ctn-kix_925qe2elwufe-2
        }

        ol.lst-kix_fa857d9azgn-4.start {
            counter-reset: lst-ctn-kix_fa857d9azgn-4 0
        }

        ol.lst-kix_2uqf52luwlch-4.start {
            counter-reset: lst-ctn-kix_2uqf52luwlch-4 0
        }

        .lst-kix_fa857d9azgn-5>li {
            counter-increment: lst-ctn-kix_fa857d9azgn-5
        }

        ol.lst-kix_b10urs79we04-8 {
            list-style-type: none
        }

        ol.lst-kix_b10urs79we04-7 {
            list-style-type: none
        }

        ol.lst-kix_b10urs79we04-6 {
            list-style-type: none
        }

        .lst-kix_j63ler45idng-6>li {
            counter-increment: lst-ctn-kix_j63ler45idng-6
        }

        .lst-kix_8svwjcre89oj-4>li {
            counter-increment: lst-ctn-kix_8svwjcre89oj-4
        }

        ol.lst-kix_b10urs79we04-1 {
            list-style-type: none
        }

        ol.lst-kix_b10urs79we04-0 {
            list-style-type: none
        }

        ol.lst-kix_b10urs79we04-3.start {
            counter-reset: lst-ctn-kix_b10urs79we04-3 0
        }

        .lst-kix_26q3elmitsqj-0>li {
            counter-increment: lst-ctn-kix_26q3elmitsqj-0
        }

        .lst-kix_ofi0mmcnclsi-6>li {
            counter-increment: lst-ctn-kix_ofi0mmcnclsi-6
        }

        ol.lst-kix_b10urs79we04-5 {
            list-style-type: none
        }

        ol.lst-kix_b10urs79we04-4 {
            list-style-type: none
        }

        ol.lst-kix_b10urs79we04-3 {
            list-style-type: none
        }

        ol.lst-kix_b10urs79we04-2 {
            list-style-type: none
        }

        ol.lst-kix_b10urs79we04-8.start {
            counter-reset: lst-ctn-kix_b10urs79we04-8 0
        }

        .lst-kix_fa857d9azgn-7>li {
            counter-increment: lst-ctn-kix_fa857d9azgn-7
        }

        ol.lst-kix_925qe2elwufe-4.start {
            counter-reset: lst-ctn-kix_925qe2elwufe-4 0
        }

        .lst-kix_ofi0mmcnclsi-8>li {
            counter-increment: lst-ctn-kix_ofi0mmcnclsi-8
        }

        .lst-kix_j63ler45idng-8>li {
            counter-increment: lst-ctn-kix_j63ler45idng-8
        }

        ol.lst-kix_j63ler45idng-5.start {
            counter-reset: lst-ctn-kix_j63ler45idng-5 0
        }

        .lst-kix_2uqf52luwlch-7>li:before {
            content: "" counter(lst-ctn-kix_2uqf52luwlch-7, lower-latin) ". "
        }

        .lst-kix_2uqf52luwlch-6>li:before {
            content: "" counter(lst-ctn-kix_2uqf52luwlch-6, decimal) ". "
        }

        .lst-kix_8svwjcre89oj-2>li {
            counter-increment: lst-ctn-kix_8svwjcre89oj-2
        }

        .lst-kix_il2ghw7mpzg3-0>li {
            counter-increment: lst-ctn-kix_il2ghw7mpzg3-0
        }

        ol.lst-kix_il2ghw7mpzg3-4.start {
            counter-reset: lst-ctn-kix_il2ghw7mpzg3-4 0
        }

        .lst-kix_2uqf52luwlch-8>li:before {
            content: "" counter(lst-ctn-kix_2uqf52luwlch-8, lower-roman) ". "
        }

        .lst-kix_9c69ktmkhots-6>li {
            counter-increment: lst-ctn-kix_9c69ktmkhots-6
        }

        ol.lst-kix_26q3elmitsqj-8.start {
            counter-reset: lst-ctn-kix_26q3elmitsqj-8 0
        }

        .lst-kix_b10urs79we04-1>li {
            counter-increment: lst-ctn-kix_b10urs79we04-1
        }

        .lst-kix_26q3elmitsqj-2>li {
            counter-increment: lst-ctn-kix_26q3elmitsqj-2
        }

        ol.lst-kix_9c69ktmkhots-8.start {
            counter-reset: lst-ctn-kix_9c69ktmkhots-8 0
        }

        ol.lst-kix_8svwjcre89oj-4.start {
            counter-reset: lst-ctn-kix_8svwjcre89oj-4 0
        }

        .lst-kix_fa857d9azgn-3>li {
            counter-increment: lst-ctn-kix_fa857d9azgn-3
        }

        .lst-kix_925qe2elwufe-4>li {
            counter-increment: lst-ctn-kix_925qe2elwufe-4
        }

        .lst-kix_b10urs79we04-3>li {
            counter-increment: lst-ctn-kix_b10urs79we04-3
        }

        ol.lst-kix_j63ler45idng-4.start {
            counter-reset: lst-ctn-kix_j63ler45idng-4 0
        }

        ol.lst-kix_ofi0mmcnclsi-5.start {
            counter-reset: lst-ctn-kix_ofi0mmcnclsi-5 0
        }

        ol.lst-kix_26q3elmitsqj-2.start {
            counter-reset: lst-ctn-kix_26q3elmitsqj-2 0
        }

        .lst-kix_2uqf52luwlch-7>li {
            counter-increment: lst-ctn-kix_2uqf52luwlch-7
        }

        .lst-kix_il2ghw7mpzg3-2>li {
            counter-increment: lst-ctn-kix_il2ghw7mpzg3-2
        }

        .lst-kix_925qe2elwufe-0>li {
            counter-increment: lst-ctn-kix_925qe2elwufe-0
        }

        ol.lst-kix_il2ghw7mpzg3-5.start {
            counter-reset: lst-ctn-kix_il2ghw7mpzg3-5 0
        }

        .lst-kix_26q3elmitsqj-4>li {
            counter-increment: lst-ctn-kix_26q3elmitsqj-4
        }

        .lst-kix_26q3elmitsqj-7>li {
            counter-increment: lst-ctn-kix_26q3elmitsqj-7
        }

        ol.lst-kix_8svwjcre89oj-5.start {
            counter-reset: lst-ctn-kix_8svwjcre89oj-5 0
        }

        ol.lst-kix_2uqf52luwlch-3.start {
            counter-reset: lst-ctn-kix_2uqf52luwlch-3 0
        }

        ol.lst-kix_26q3elmitsqj-3.start {
            counter-reset: lst-ctn-kix_26q3elmitsqj-3 0
        }

        ol.lst-kix_9c69ktmkhots-3.start {
            counter-reset: lst-ctn-kix_9c69ktmkhots-3 0
        }

        .lst-kix_8svwjcre89oj-7>li:before {
            content: "" counter(lst-ctn-kix_8svwjcre89oj-7, lower-latin) ". "
        }

        .lst-kix_26q3elmitsqj-2>li:before {
            content: "" counter(lst-ctn-kix_26q3elmitsqj-2, lower-roman) ". "
        }

        .lst-kix_j63ler45idng-1>li {
            counter-increment: lst-ctn-kix_j63ler45idng-1
        }

        ol.lst-kix_b10urs79we04-7.start {
            counter-reset: lst-ctn-kix_b10urs79we04-7 0
        }

        ol.lst-kix_il2ghw7mpzg3-6.start {
            counter-reset: lst-ctn-kix_il2ghw7mpzg3-6 0
        }

        .lst-kix_26q3elmitsqj-6>li:before {
            content: "" counter(lst-ctn-kix_26q3elmitsqj-6, decimal) ". "
        }

        .lst-kix_8svwjcre89oj-5>li:before {
            content: "" counter(lst-ctn-kix_8svwjcre89oj-5, lower-roman) ". "
        }

        .lst-kix_26q3elmitsqj-4>li:before {
            content: "" counter(lst-ctn-kix_26q3elmitsqj-4, lower-latin) ". "
        }

        ol.lst-kix_925qe2elwufe-5.start {
            counter-reset: lst-ctn-kix_925qe2elwufe-5 0
        }

        ol.lst-kix_9c69ktmkhots-7 {
            list-style-type: none
        }

        .lst-kix_rznbj4qtambp-6>li:before {
            content: "\\0025cf  "
        }

        ol.lst-kix_9c69ktmkhots-8 {
            list-style-type: none
        }

        ol.lst-kix_9c69ktmkhots-5 {
            list-style-type: none
        }

        ol.lst-kix_9c69ktmkhots-6 {
            list-style-type: none
        }

        .lst-kix_rznbj4qtambp-4>li:before {
            content: "\\0025cb  "
        }

        .lst-kix_rznbj4qtambp-8>li:before {
            content: "\\0025a0  "
        }

        .lst-kix_b10urs79we04-5>li:before {
            content: "" counter(lst-ctn-kix_b10urs79we04-5, lower-roman) ". "
        }

        .lst-kix_j63ler45idng-2>li {
            counter-increment: lst-ctn-kix_j63ler45idng-2
        }

        .lst-kix_8svwjcre89oj-3>li:before {
            content: "" counter(lst-ctn-kix_8svwjcre89oj-3, decimal) ". "
        }

        ol.lst-kix_9c69ktmkhots-0 {
            list-style-type: none
        }

        .lst-kix_fa857d9azgn-0>li:before {
            content: "3." counter(lst-ctn-kix_fa857d9azgn-0, decimal) ". "
        }

        .lst-kix_b10urs79we04-3>li:before {
            content: "" counter(lst-ctn-kix_b10urs79we04-3, decimal) ". "
        }

        ol.lst-kix_9c69ktmkhots-3 {
            list-style-type: none
        }

        .lst-kix_8svwjcre89oj-1>li:before {
            content: "" counter(lst-ctn-kix_8svwjcre89oj-1, lower-latin) ". "
        }

        ol.lst-kix_9c69ktmkhots-4 {
            list-style-type: none
        }

        .lst-kix_26q3elmitsqj-0>li:before {
            content: "2." counter(lst-ctn-kix_26q3elmitsqj-0, decimal) ". "
        }

        ol.lst-kix_9c69ktmkhots-1 {
            list-style-type: none
        }

        .lst-kix_il2ghw7mpzg3-5>li {
            counter-increment: lst-ctn-kix_il2ghw7mpzg3-5
        }

        ol.lst-kix_9c69ktmkhots-2 {
            list-style-type: none
        }

        ol.lst-kix_fa857d9azgn-7 {
            list-style-type: none
        }

        ol.lst-kix_fa857d9azgn-8 {
            list-style-type: none
        }

        .lst-kix_2uqf52luwlch-5>li {
            counter-increment: lst-ctn-kix_2uqf52luwlch-5
        }

        .lst-kix_b10urs79we04-1>li:before {
            content: "" counter(lst-ctn-kix_b10urs79we04-1, lower-latin) ". "
        }

        .lst-kix_925qe2elwufe-6>li {
            counter-increment: lst-ctn-kix_925qe2elwufe-6
        }

        ol.lst-kix_ofi0mmcnclsi-8.start {
            counter-reset: lst-ctn-kix_ofi0mmcnclsi-8 0
        }

        ol.lst-kix_fa857d9azgn-1 {
            list-style-type: none
        }

        ol.lst-kix_fa857d9azgn-2 {
            list-style-type: none
        }

        .lst-kix_8svwjcre89oj-7>li {
            counter-increment: lst-ctn-kix_8svwjcre89oj-7
        }

        ol.lst-kix_fa857d9azgn-0 {
            list-style-type: none
        }

        ol.lst-kix_fa857d9azgn-5 {
            list-style-type: none
        }

        ol.lst-kix_fa857d9azgn-5.start {
            counter-reset: lst-ctn-kix_fa857d9azgn-5 0
        }

        .lst-kix_fa857d9azgn-2>li:before {
            content: "" counter(lst-ctn-kix_fa857d9azgn-2, lower-roman) ". "
        }

        ol.lst-kix_fa857d9azgn-6 {
            list-style-type: none
        }

        ol.lst-kix_26q3elmitsqj-1.start {
            counter-reset: lst-ctn-kix_26q3elmitsqj-1 0
        }

        .lst-kix_fa857d9azgn-1>li {
            counter-increment: lst-ctn-kix_fa857d9azgn-1
        }

        ol.lst-kix_fa857d9azgn-3 {
            list-style-type: none
        }

        .lst-kix_j63ler45idng-0>li {
            counter-increment: lst-ctn-kix_j63ler45idng-0
        }

        ol.lst-kix_fa857d9azgn-4 {
            list-style-type: none
        }

        ol.lst-kix_j63ler45idng-2 {
            list-style-type: none
        }

        ol.lst-kix_j63ler45idng-3 {
            list-style-type: none
        }

        .lst-kix_fa857d9azgn-4>li:before {
            content: "" counter(lst-ctn-kix_fa857d9azgn-4, lower-latin) ". "
        }

        ol.lst-kix_j63ler45idng-0 {
            list-style-type: none
        }

        ol.lst-kix_j63ler45idng-1 {
            list-style-type: none
        }

        ol.lst-kix_j63ler45idng-6 {
            list-style-type: none
        }

        ol.lst-kix_8svwjcre89oj-6.start {
            counter-reset: lst-ctn-kix_8svwjcre89oj-6 0
        }

        ol.lst-kix_j63ler45idng-7 {
            list-style-type: none
        }

        ol.lst-kix_j63ler45idng-4 {
            list-style-type: none
        }

        .lst-kix_ofi0mmcnclsi-8>li:before {
            content: "" counter(lst-ctn-kix_ofi0mmcnclsi-8, lower-roman) ". "
        }

        ol.lst-kix_j63ler45idng-5 {
            list-style-type: none
        }

        .lst-kix_il2ghw7mpzg3-3>li {
            counter-increment: lst-ctn-kix_il2ghw7mpzg3-3
        }

        .lst-kix_fa857d9azgn-8>li:before {
            content: "" counter(lst-ctn-kix_fa857d9azgn-8, lower-roman) ". "
        }

        .lst-kix_26q3elmitsqj-8>li {
            counter-increment: lst-ctn-kix_26q3elmitsqj-8
        }

        ol.lst-kix_j63ler45idng-8 {
            list-style-type: none
        }

        .lst-kix_fa857d9azgn-6>li:before {
            content: "" counter(lst-ctn-kix_fa857d9azgn-6, decimal) ". "
        }

        .lst-kix_b10urs79we04-7>li {
            counter-increment: lst-ctn-kix_b10urs79we04-7
        }

        ol.lst-kix_9c69ktmkhots-7.start {
            counter-reset: lst-ctn-kix_9c69ktmkhots-7 0
        }

        .lst-kix_ofi0mmcnclsi-4>li {
            counter-increment: lst-ctn-kix_ofi0mmcnclsi-4
        }

        ol.lst-kix_il2ghw7mpzg3-8.start {
            counter-reset: lst-ctn-kix_il2ghw7mpzg3-8 0
        }

        .lst-kix_8svwjcre89oj-0>li {
            counter-increment: lst-ctn-kix_8svwjcre89oj-0
        }

        ol.lst-kix_j63ler45idng-1.start {
            counter-reset: lst-ctn-kix_j63ler45idng-1 0
        }

        .lst-kix_2uqf52luwlch-0>li {
            counter-increment: lst-ctn-kix_2uqf52luwlch-0
        }

        .lst-kix_2uqf52luwlch-4>li:before {
            content: "" counter(lst-ctn-kix_2uqf52luwlch-4, lower-latin) ". "
        }

        .lst-kix_fa857d9azgn-2>li {
            counter-increment: lst-ctn-kix_fa857d9azgn-2
        }

        ol.lst-kix_8svwjcre89oj-7.start {
            counter-reset: lst-ctn-kix_8svwjcre89oj-7 0
        }

        .lst-kix_9c69ktmkhots-2>li {
            counter-increment: lst-ctn-kix_9c69ktmkhots-2
        }

        ol.lst-kix_fa857d9azgn-2.start {
            counter-reset: lst-ctn-kix_fa857d9azgn-2 0
        }

        .lst-kix_26q3elmitsqj-3>li {
            counter-increment: lst-ctn-kix_26q3elmitsqj-3
        }

        .lst-kix_fa857d9azgn-8>li {
            counter-increment: lst-ctn-kix_fa857d9azgn-8
        }

        .lst-kix_il2ghw7mpzg3-1>li:before {
            content: "9." counter(lst-ctn-kix_il2ghw7mpzg3-1, decimal) ". "
        }

        .lst-kix_il2ghw7mpzg3-5>li:before {
            content: "" counter(lst-ctn-kix_il2ghw7mpzg3-5, lower-roman) ". "
        }

        .lst-kix_2uqf52luwlch-0>li:before {
            content: "6." counter(lst-ctn-kix_2uqf52luwlch-0, decimal) ". "
        }

        ol.lst-kix_925qe2elwufe-3.start {
            counter-reset: lst-ctn-kix_925qe2elwufe-3 0
        }

        .lst-kix_2uqf52luwlch-2>li:before {
            content: "" counter(lst-ctn-kix_2uqf52luwlch-2, lower-roman) ". "
        }

        .lst-kix_9c69ktmkhots-8>li {
            counter-increment: lst-ctn-kix_9c69ktmkhots-8
        }

        .lst-kix_il2ghw7mpzg3-3>li:before {
            content: "" counter(lst-ctn-kix_il2ghw7mpzg3-3, decimal) ". "
        }

        ol.lst-kix_j63ler45idng-0.start {
            counter-reset: lst-ctn-kix_j63ler45idng-0 0
        }

        .lst-kix_b10urs79we04-8>li {
            counter-increment: lst-ctn-kix_b10urs79we04-8
        }

        .lst-kix_rznbj4qtambp-0>li:before {
            content: "\\0025cf  "
        }

        ol.lst-kix_9c69ktmkhots-6.start {
            counter-reset: lst-ctn-kix_9c69ktmkhots-6 0
        }

        .lst-kix_b10urs79we04-2>li {
            counter-increment: lst-ctn-kix_b10urs79we04-2
        }

        .lst-kix_rznbj4qtambp-2>li:before {
            content: "\\0025a0  "
        }

        ol.lst-kix_8svwjcre89oj-8.start {
            counter-reset: lst-ctn-kix_8svwjcre89oj-8 0
        }

        .lst-kix_il2ghw7mpzg3-4>li {
            counter-increment: lst-ctn-kix_il2ghw7mpzg3-4
        }

        ol.lst-kix_925qe2elwufe-0 {
            list-style-type: none
        }

        ol.lst-kix_925qe2elwufe-2.start {
            counter-reset: lst-ctn-kix_925qe2elwufe-2 0
        }

        ol.lst-kix_fa857d9azgn-3.start {
            counter-reset: lst-ctn-kix_fa857d9azgn-3 0
        }

        ol.lst-kix_26q3elmitsqj-0.start {
            counter-reset: lst-ctn-kix_26q3elmitsqj-0 0
        }

        .lst-kix_2uqf52luwlch-6>li {
            counter-increment: lst-ctn-kix_2uqf52luwlch-6
        }

        .lst-kix_925qe2elwufe-5>li {
            counter-increment: lst-ctn-kix_925qe2elwufe-5
        }

        ol.lst-kix_2uqf52luwlch-0.start {
            counter-reset: lst-ctn-kix_2uqf52luwlch-0 0
        }

        .lst-kix_26q3elmitsqj-8>li:before {
            content: "" counter(lst-ctn-kix_26q3elmitsqj-8, lower-roman) ". "
        }

        .lst-kix_8svwjcre89oj-6>li {
            counter-increment: lst-ctn-kix_8svwjcre89oj-6
        }

        .lst-kix_j63ler45idng-3>li:before {
            content: "" counter(lst-ctn-kix_j63ler45idng-3, decimal) ". "
        }

        .lst-kix_8svwjcre89oj-3>li {
            counter-increment: lst-ctn-kix_8svwjcre89oj-3
        }

        .lst-kix_j63ler45idng-7>li {
            counter-increment: lst-ctn-kix_j63ler45idng-7
        }

        .lst-kix_j63ler45idng-0>li:before {
            content: "5." counter(lst-ctn-kix_j63ler45idng-0, decimal) ". "
        }

        .lst-kix_j63ler45idng-4>li:before {
            content: "" counter(lst-ctn-kix_j63ler45idng-4, lower-latin) ". "
        }

        .lst-kix_ofi0mmcnclsi-7>li {
            counter-increment: lst-ctn-kix_ofi0mmcnclsi-7
        }

        ol.lst-kix_2uqf52luwlch-7.start {
            counter-reset: lst-ctn-kix_2uqf52luwlch-7 0
        }

        .lst-kix_fa857d9azgn-6>li {
            counter-increment: lst-ctn-kix_fa857d9azgn-6
        }

        ol.lst-kix_fa857d9azgn-1.start {
            counter-reset: lst-ctn-kix_fa857d9azgn-1 0
        }

        .lst-kix_j63ler45idng-1>li:before {
            content: "" counter(lst-ctn-kix_j63ler45idng-1, lower-latin) ". "
        }

        ol.lst-kix_8svwjcre89oj-0 {
            list-style-type: none
        }

        .lst-kix_j63ler45idng-2>li:before {
            content: "" counter(lst-ctn-kix_j63ler45idng-2, lower-roman) ". "
        }

        ol.lst-kix_8svwjcre89oj-2 {
            list-style-type: none
        }

        ol.lst-kix_9c69ktmkhots-5.start {
            counter-reset: lst-ctn-kix_9c69ktmkhots-5 0
        }

        ol.lst-kix_8svwjcre89oj-1 {
            list-style-type: none
        }

        ol.lst-kix_925qe2elwufe-3 {
            list-style-type: none
        }

        ol.lst-kix_925qe2elwufe-4 {
            list-style-type: none
        }

        ol.lst-kix_925qe2elwufe-1 {
            list-style-type: none
        }

        ol.lst-kix_925qe2elwufe-2 {
            list-style-type: none
        }

        .lst-kix_9c69ktmkhots-1>li:before {
            content: "" counter(lst-ctn-kix_9c69ktmkhots-1, lower-latin) ". "
        }

        .lst-kix_9c69ktmkhots-3>li:before {
            content: "" counter(lst-ctn-kix_9c69ktmkhots-3, decimal) ". "
        }

        ol.lst-kix_ofi0mmcnclsi-7.start {
            counter-reset: lst-ctn-kix_ofi0mmcnclsi-7 0
        }

        ol.lst-kix_925qe2elwufe-7 {
            list-style-type: none
        }

        ol.lst-kix_ofi0mmcnclsi-8 {
            list-style-type: none
        }

        ol.lst-kix_925qe2elwufe-8 {
            list-style-type: none
        }

        ol.lst-kix_ofi0mmcnclsi-7 {
            list-style-type: none
        }

        ol.lst-kix_925qe2elwufe-5 {
            list-style-type: none
        }

        ol.lst-kix_j63ler45idng-2.start {
            counter-reset: lst-ctn-kix_j63ler45idng-2 0
        }

        ol.lst-kix_925qe2elwufe-6 {
            list-style-type: none
        }

        .lst-kix_9c69ktmkhots-2>li:before {
            content: "" counter(lst-ctn-kix_9c69ktmkhots-2, lower-roman) ". "
        }

        .lst-kix_9c69ktmkhots-5>li {
            counter-increment: lst-ctn-kix_9c69ktmkhots-5
        }

        ol.lst-kix_ofi0mmcnclsi-4 {
            list-style-type: none
        }

        ol.lst-kix_b10urs79we04-0.start {
            counter-reset: lst-ctn-kix_b10urs79we04-0 0
        }

        ol.lst-kix_8svwjcre89oj-2.start {
            counter-reset: lst-ctn-kix_8svwjcre89oj-2 0
        }

        ol.lst-kix_ofi0mmcnclsi-3 {
            list-style-type: none
        }

        ol.lst-kix_ofi0mmcnclsi-6 {
            list-style-type: none
        }

        ol.lst-kix_ofi0mmcnclsi-5 {
            list-style-type: none
        }

        ol.lst-kix_ofi0mmcnclsi-0 {
            list-style-type: none
        }

        .lst-kix_925qe2elwufe-3>li {
            counter-increment: lst-ctn-kix_925qe2elwufe-3
        }

        ol.lst-kix_ofi0mmcnclsi-2 {
            list-style-type: none
        }

        .lst-kix_9c69ktmkhots-0>li:before {
            content: "1." counter(lst-ctn-kix_9c69ktmkhots-0, decimal) ". "
        }

        ol.lst-kix_ofi0mmcnclsi-1 {
            list-style-type: none
        }

        ol.lst-kix_fa857d9azgn-7.start {
            counter-reset: lst-ctn-kix_fa857d9azgn-7 0
        }

        ol.lst-kix_il2ghw7mpzg3-7.start {
            counter-reset: lst-ctn-kix_il2ghw7mpzg3-7 0
        }

        ol.lst-kix_2uqf52luwlch-1.start {
            counter-reset: lst-ctn-kix_2uqf52luwlch-1 0
        }

        .lst-kix_fa857d9azgn-4>li {
            counter-increment: lst-ctn-kix_fa857d9azgn-4
        }

        .lst-kix_j63ler45idng-5>li {
            counter-increment: lst-ctn-kix_j63ler45idng-5
        }

        .lst-kix_il2ghw7mpzg3-6>li:before {
            content: "" counter(lst-ctn-kix_il2ghw7mpzg3-6, decimal) ". "
        }

        ol.lst-kix_26q3elmitsqj-5.start {
            counter-reset: lst-ctn-kix_26q3elmitsqj-5 0
        }

        ol.lst-kix_925qe2elwufe-1.start {
            counter-reset: lst-ctn-kix_925qe2elwufe-1 0
        }

        .lst-kix_9c69ktmkhots-5>li:before {
            content: "" counter(lst-ctn-kix_9c69ktmkhots-5, lower-roman) ". "
        }

        .lst-kix_8svwjcre89oj-5>li {
            counter-increment: lst-ctn-kix_8svwjcre89oj-5
        }

        .lst-kix_il2ghw7mpzg3-8>li:before {
            content: "" counter(lst-ctn-kix_il2ghw7mpzg3-8, lower-roman) ". "
        }

        .lst-kix_9c69ktmkhots-4>li:before {
            content: "" counter(lst-ctn-kix_9c69ktmkhots-4, lower-latin) ". "
        }

        .lst-kix_2uqf52luwlch-8>li {
            counter-increment: lst-ctn-kix_2uqf52luwlch-8
        }

        .lst-kix_il2ghw7mpzg3-7>li:before {
            content: "" counter(lst-ctn-kix_il2ghw7mpzg3-7, lower-latin) ". "
        }

        .lst-kix_ofi0mmcnclsi-5>li {
            counter-increment: lst-ctn-kix_ofi0mmcnclsi-5
        }

        ol.lst-kix_8svwjcre89oj-4 {
            list-style-type: none
        }

        .lst-kix_925qe2elwufe-1>li {
            counter-increment: lst-ctn-kix_925qe2elwufe-1
        }

        ol.lst-kix_8svwjcre89oj-3 {
            list-style-type: none
        }

        ol.lst-kix_8svwjcre89oj-6 {
            list-style-type: none
        }

        ol.lst-kix_8svwjcre89oj-5 {
            list-style-type: none
        }

        ol.lst-kix_8svwjcre89oj-8 {
            list-style-type: none
        }

        ol.lst-kix_8svwjcre89oj-7 {
            list-style-type: none
        }

        .lst-kix_j63ler45idng-8>li:before {
            content: "" counter(lst-ctn-kix_j63ler45idng-8, lower-roman) ". "
        }

        .lst-kix_j63ler45idng-7>li:before {
            content: "" counter(lst-ctn-kix_j63ler45idng-7, lower-latin) ". "
        }

        .lst-kix_9c69ktmkhots-6>li:before {
            content: "" counter(lst-ctn-kix_9c69ktmkhots-6, decimal) ". "
        }

        ol.lst-kix_925qe2elwufe-7.start {
            counter-reset: lst-ctn-kix_925qe2elwufe-7 0
        }

        ol.lst-kix_j63ler45idng-8.start {
            counter-reset: lst-ctn-kix_j63ler45idng-8 0
        }

        .lst-kix_9c69ktmkhots-7>li:before {
            content: "" counter(lst-ctn-kix_9c69ktmkhots-7, lower-latin) ". "
        }

        .lst-kix_j63ler45idng-5>li:before {
            content: "" counter(lst-ctn-kix_j63ler45idng-5, lower-roman) ". "
        }

        .lst-kix_9c69ktmkhots-8>li:before {
            content: "" counter(lst-ctn-kix_9c69ktmkhots-8, lower-roman) ". "
        }

        .lst-kix_j63ler45idng-6>li:before {
            content: "" counter(lst-ctn-kix_j63ler45idng-6, decimal) ". "
        }

        .lst-kix_9c69ktmkhots-3>li {
            counter-increment: lst-ctn-kix_9c69ktmkhots-3
        }

        ol.lst-kix_ofi0mmcnclsi-1.start {
            counter-reset: lst-ctn-kix_ofi0mmcnclsi-1 0
        }

        .lst-kix_925qe2elwufe-8>li:before {
            content: "" counter(lst-ctn-kix_925qe2elwufe-8, lower-roman) ". "
        }

        .lst-kix_il2ghw7mpzg3-8>li {
            counter-increment: lst-ctn-kix_il2ghw7mpzg3-8
        }

        ol.lst-kix_925qe2elwufe-0.start {
            counter-reset: lst-ctn-kix_925qe2elwufe-0 0
        }

        .lst-kix_925qe2elwufe-6>li:before {
            content: "" counter(lst-ctn-kix_925qe2elwufe-6, decimal) ". "
        }

        .lst-kix_2uqf52luwlch-1>li {
            counter-increment: lst-ctn-kix_2uqf52luwlch-1
        }

        .lst-kix_925qe2elwufe-7>li:before {
            content: "" counter(lst-ctn-kix_925qe2elwufe-7, lower-latin) ". "
        }

        ol.lst-kix_fa857d9azgn-6.start {
            counter-reset: lst-ctn-kix_fa857d9azgn-6 0
        }

        .lst-kix_9c69ktmkhots-1>li {
            counter-increment: lst-ctn-kix_9c69ktmkhots-1
        }

        .lst-kix_925qe2elwufe-4>li:before {
            content: "" counter(lst-ctn-kix_925qe2elwufe-4, lower-latin) ". "
        }

        ol.lst-kix_2uqf52luwlch-2.start {
            counter-reset: lst-ctn-kix_2uqf52luwlch-2 0
        }

        .lst-kix_ofi0mmcnclsi-7>li:before {
            content: "" counter(lst-ctn-kix_ofi0mmcnclsi-7, lower-latin) ". "
        }

        ol.lst-kix_26q3elmitsqj-8 {
            list-style-type: none
        }

        .lst-kix_925qe2elwufe-5>li:before {
            content: "" counter(lst-ctn-kix_925qe2elwufe-5, lower-roman) ". "
        }

        .lst-kix_9c69ktmkhots-7>li {
            counter-increment: lst-ctn-kix_9c69ktmkhots-7
        }

        .lst-kix_ofi0mmcnclsi-6>li:before {
            content: "" counter(lst-ctn-kix_ofi0mmcnclsi-6, decimal) ". "
        }

        ol.lst-kix_26q3elmitsqj-7 {
            list-style-type: none
        }

        ol.lst-kix_26q3elmitsqj-6 {
            list-style-type: none
        }

        .lst-kix_925qe2elwufe-0>li:before {
            content: "4." counter(lst-ctn-kix_925qe2elwufe-0, decimal) ". "
        }

        ol.lst-kix_9c69ktmkhots-4.start {
            counter-reset: lst-ctn-kix_9c69ktmkhots-4 0
        }

        .lst-kix_ofi0mmcnclsi-5>li:before {
            content: "" counter(lst-ctn-kix_ofi0mmcnclsi-5, lower-roman) ". "
        }

        .lst-kix_925qe2elwufe-2>li:before {
            content: "" counter(lst-ctn-kix_925qe2elwufe-2, lower-roman) ". "
        }

        .lst-kix_j63ler45idng-3>li {
            counter-increment: lst-ctn-kix_j63ler45idng-3
        }

        .lst-kix_ofi0mmcnclsi-4>li:before {
            content: "" counter(lst-ctn-kix_ofi0mmcnclsi-4, lower-latin) ". "
        }

        .lst-kix_925qe2elwufe-3>li:before {
            content: "" counter(lst-ctn-kix_925qe2elwufe-3, decimal) ". "
        }

        ol.lst-kix_b10urs79we04-5.start {
            counter-reset: lst-ctn-kix_b10urs79we04-5 0
        }

        .lst-kix_ofi0mmcnclsi-3>li {
            counter-increment: lst-ctn-kix_ofi0mmcnclsi-3
        }

        .lst-kix_ofi0mmcnclsi-1>li:before {
            content: "" counter(lst-ctn-kix_ofi0mmcnclsi-1, lower-latin) ". "
        }

        .lst-kix_ofi0mmcnclsi-2>li:before {
            content: "" counter(lst-ctn-kix_ofi0mmcnclsi-2, lower-roman) ". "
        }

        .lst-kix_8svwjcre89oj-1>li {
            counter-increment: lst-ctn-kix_8svwjcre89oj-1
        }

        .lst-kix_ofi0mmcnclsi-3>li:before {
            content: "" counter(lst-ctn-kix_ofi0mmcnclsi-3, decimal) ". "
        }

        .lst-kix_925qe2elwufe-1>li:before {
            content: "4.2." counter(lst-ctn-kix_925qe2elwufe-1, decimal) ". "
        }

        .lst-kix_26q3elmitsqj-1>li {
            counter-increment: lst-ctn-kix_26q3elmitsqj-1
        }

        ol.lst-kix_fa857d9azgn-0.start {
            counter-reset: lst-ctn-kix_fa857d9azgn-0 0
        }

        ol.lst-kix_925qe2elwufe-6.start {
            counter-reset: lst-ctn-kix_925qe2elwufe-6 0
        }

        .lst-kix_ofi0mmcnclsi-0>li:before {
            content: "" counter(lst-ctn-kix_ofi0mmcnclsi-0, decimal) ". "
        }

        ol.lst-kix_il2ghw7mpzg3-2 {
            list-style-type: none
        }

        ol.lst-kix_il2ghw7mpzg3-3 {
            list-style-type: none
        }

        ol.lst-kix_il2ghw7mpzg3-0 {
            list-style-type: none
        }

        ol.lst-kix_il2ghw7mpzg3-1 {
            list-style-type: none
        }

        ol.lst-kix_b10urs79we04-6.start {
            counter-reset: lst-ctn-kix_b10urs79we04-6 0
        }

        ol.lst-kix_26q3elmitsqj-5 {
            list-style-type: none
        }

        ol.lst-kix_j63ler45idng-3.start {
            counter-reset: lst-ctn-kix_j63ler45idng-3 0
        }

        ol.lst-kix_26q3elmitsqj-4 {
            list-style-type: none
        }

        .lst-kix_b10urs79we04-7>li:before {
            content: "" counter(lst-ctn-kix_b10urs79we04-7, lower-latin) ". "
        }

        ol.lst-kix_il2ghw7mpzg3-8 {
            list-style-type: none
        }

        ol.lst-kix_26q3elmitsqj-3 {
            list-style-type: none
        }

        .lst-kix_b10urs79we04-0>li {
            counter-increment: lst-ctn-kix_b10urs79we04-0
        }

        ol.lst-kix_ofi0mmcnclsi-6.start {
            counter-reset: lst-ctn-kix_ofi0mmcnclsi-6 0
        }

        ol.lst-kix_26q3elmitsqj-2 {
            list-style-type: none
        }

        ol.lst-kix_il2ghw7mpzg3-6 {
            list-style-type: none
        }

        ol.lst-kix_26q3elmitsqj-1 {
            list-style-type: none
        }

        ol.lst-kix_il2ghw7mpzg3-7 {
            list-style-type: none
        }

        ol.lst-kix_26q3elmitsqj-0 {
            list-style-type: none
        }

        .lst-kix_b10urs79we04-8>li:before {
            content: "" counter(lst-ctn-kix_b10urs79we04-8, lower-roman) ". "
        }

        ol.lst-kix_il2ghw7mpzg3-4 {
            list-style-type: none
        }

        ol.lst-kix_il2ghw7mpzg3-5 {
            list-style-type: none
        }

        ol.lst-kix_2uqf52luwlch-5 {
            list-style-type: none
        }

        ol.lst-kix_2uqf52luwlch-6 {
            list-style-type: none
        }

        .lst-kix_8svwjcre89oj-8>li:before {
            content: "" counter(lst-ctn-kix_8svwjcre89oj-8, lower-roman) ". "
        }

        .lst-kix_26q3elmitsqj-3>li:before {
            content: "" counter(lst-ctn-kix_26q3elmitsqj-3, decimal) ". "
        }

        ol.lst-kix_2uqf52luwlch-3 {
            list-style-type: none
        }

        ol.lst-kix_j63ler45idng-6.start {
            counter-reset: lst-ctn-kix_j63ler45idng-6 0
        }

        ol.lst-kix_2uqf52luwlch-4 {
            list-style-type: none
        }

        ol.lst-kix_2uqf52luwlch-1 {
            list-style-type: none
        }

        .lst-kix_fa857d9azgn-0>li {
            counter-increment: lst-ctn-kix_fa857d9azgn-0
        }

        ol.lst-kix_2uqf52luwlch-2 {
            list-style-type: none
        }

        ol.lst-kix_2uqf52luwlch-0 {
            list-style-type: none
        }

        ol.lst-kix_26q3elmitsqj-4.start {
            counter-reset: lst-ctn-kix_26q3elmitsqj-4 0
        }

        .lst-kix_8svwjcre89oj-4>li:before {
            content: "" counter(lst-ctn-kix_8svwjcre89oj-4, lower-latin) ". "
        }

        .lst-kix_925qe2elwufe-7>li {
            counter-increment: lst-ctn-kix_925qe2elwufe-7
        }

        ol.lst-kix_il2ghw7mpzg3-3.start {
            counter-reset: lst-ctn-kix_il2ghw7mpzg3-3 0
        }

        .lst-kix_8svwjcre89oj-6>li:before {
            content: "" counter(lst-ctn-kix_8svwjcre89oj-6, decimal) ". "
        }

        .lst-kix_26q3elmitsqj-5>li:before {
            content: "" counter(lst-ctn-kix_26q3elmitsqj-5, lower-roman) ". "
        }

        .lst-kix_26q3elmitsqj-6>li {
            counter-increment: lst-ctn-kix_26q3elmitsqj-6
        }

        ol.lst-kix_2uqf52luwlch-7 {
            list-style-type: none
        }

        ol.lst-kix_2uqf52luwlch-8 {
            list-style-type: none
        }

        ul.lst-kix_rznbj4qtambp-0 {
            list-style-type: none
        }

        ul.lst-kix_rznbj4qtambp-1 {
            list-style-type: none
        }

        .lst-kix_rznbj4qtambp-7>li:before {
            content: "\\0025cb  "
        }

        .lst-kix_8svwjcre89oj-0>li:before {
            content: "8." counter(lst-ctn-kix_8svwjcre89oj-0, decimal) ". "
        }

        .lst-kix_b10urs79we04-6>li:before {
            content: "" counter(lst-ctn-kix_b10urs79we04-6, decimal) ". "
        }

        ol.lst-kix_925qe2elwufe-8.start {
            counter-reset: lst-ctn-kix_925qe2elwufe-8 0
        }

        ul.lst-kix_rznbj4qtambp-4 {
            list-style-type: none
        }

        .lst-kix_8svwjcre89oj-8>li {
            counter-increment: lst-ctn-kix_8svwjcre89oj-8
        }

        ul.lst-kix_rznbj4qtambp-5 {
            list-style-type: none
        }

        .lst-kix_fa857d9azgn-1>li:before {
            content: "3.2." counter(lst-ctn-kix_fa857d9azgn-1, decimal) ". "
        }

        .lst-kix_b10urs79we04-4>li:before {
            content: "" counter(lst-ctn-kix_b10urs79we04-4, lower-latin) ". "
        }

        .lst-kix_b10urs79we04-6>li {
            counter-increment: lst-ctn-kix_b10urs79we04-6
        }

        ul.lst-kix_rznbj4qtambp-2 {
            list-style-type: none
        }

        ol.lst-kix_ofi0mmcnclsi-0.start {
            counter-reset: lst-ctn-kix_ofi0mmcnclsi-0 0
        }

        ul.lst-kix_rznbj4qtambp-3 {
            list-style-type: none
        }

        ul.lst-kix_rznbj4qtambp-8 {
            list-style-type: none
        }

        .lst-kix_2uqf52luwlch-4>li {
            counter-increment: lst-ctn-kix_2uqf52luwlch-4
        }

        .lst-kix_b10urs79we04-2>li:before {
            content: "" counter(lst-ctn-kix_b10urs79we04-2, lower-roman) ". "
        }

        ul.lst-kix_rznbj4qtambp-6 {
            list-style-type: none
        }

        ul.lst-kix_rznbj4qtambp-7 {
            list-style-type: none
        }

        ol.lst-kix_il2ghw7mpzg3-0.start {
            counter-reset: lst-ctn-kix_il2ghw7mpzg3-0 0
        }

        .lst-kix_rznbj4qtambp-5>li:before {
            content: "\\0025a0  "
        }

        .lst-kix_8svwjcre89oj-2>li:before {
            content: "" counter(lst-ctn-kix_8svwjcre89oj-2, lower-roman) ". "
        }

        .lst-kix_26q3elmitsqj-1>li:before {
            content: "2.1." counter(lst-ctn-kix_26q3elmitsqj-1, decimal) ". "
        }

        ol.lst-kix_26q3elmitsqj-7.start {
            counter-reset: lst-ctn-kix_26q3elmitsqj-7 0
        }

        ol.lst-kix_9c69ktmkhots-1.start {
            counter-reset: lst-ctn-kix_9c69ktmkhots-1 0
        }

        ol.lst-kix_b10urs79we04-1.start {
            counter-reset: lst-ctn-kix_b10urs79we04-1 0
        }

        .lst-kix_2uqf52luwlch-2>li {
            counter-increment: lst-ctn-kix_2uqf52luwlch-2
        }

        ol.lst-kix_8svwjcre89oj-3.start {
            counter-reset: lst-ctn-kix_8svwjcre89oj-3 0
        }

        .lst-kix_b10urs79we04-0>li:before {
            content: "7." counter(lst-ctn-kix_b10urs79we04-0, decimal) ". "
        }

        .lst-kix_ofi0mmcnclsi-0>li {
            counter-increment: lst-ctn-kix_ofi0mmcnclsi-0
        }

        .lst-kix_ofi0mmcnclsi-2>li {
            counter-increment: lst-ctn-kix_ofi0mmcnclsi-2
        }

        ol.lst-kix_8svwjcre89oj-0.start {
            counter-reset: lst-ctn-kix_8svwjcre89oj-0 0
        }

        .lst-kix_fa857d9azgn-3>li:before {
            content: "" counter(lst-ctn-kix_fa857d9azgn-3, decimal) ". "
        }

        .lst-kix_il2ghw7mpzg3-6>li {
            counter-increment: lst-ctn-kix_il2ghw7mpzg3-6
        }

        ol.lst-kix_2uqf52luwlch-5.start {
            counter-reset: lst-ctn-kix_2uqf52luwlch-5 0
        }

        ol.lst-kix_fa857d9azgn-8.start {
            counter-reset: lst-ctn-kix_fa857d9azgn-8 0
        }

        .lst-kix_fa857d9azgn-5>li:before {
            content: "" counter(lst-ctn-kix_fa857d9azgn-5, lower-roman) ". "
        }

        .lst-kix_fa857d9azgn-7>li:before {
            content: "" counter(lst-ctn-kix_fa857d9azgn-7, lower-latin) ". "
        }

        .lst-kix_26q3elmitsqj-5>li {
            counter-increment: lst-ctn-kix_26q3elmitsqj-5
        }

        .lst-kix_b10urs79we04-4>li {
            counter-increment: lst-ctn-kix_b10urs79we04-4
        }

        .lst-kix_9c69ktmkhots-0>li {
            counter-increment: lst-ctn-kix_9c69ktmkhots-0
        }

        ol.lst-kix_2uqf52luwlch-8.start {
            counter-reset: lst-ctn-kix_2uqf52luwlch-8 0
        }

        ol.lst-kix_b10urs79we04-4.start {
            counter-reset: lst-ctn-kix_b10urs79we04-4 0
        }

        ol.lst-kix_il2ghw7mpzg3-1.start {
            counter-reset: lst-ctn-kix_il2ghw7mpzg3-1 0
        }

        ol.lst-kix_b10urs79we04-2.start {
            counter-reset: lst-ctn-kix_b10urs79we04-2 0
        }

        ol.lst-kix_9c69ktmkhots-0.start {
            counter-reset: lst-ctn-kix_9c69ktmkhots-0 0
        }

        .lst-kix_il2ghw7mpzg3-0>li:before {
            content: "9." counter(lst-ctn-kix_il2ghw7mpzg3-0, decimal) ". "
        }

        .lst-kix_il2ghw7mpzg3-2>li:before {
            content: "" counter(lst-ctn-kix_il2ghw7mpzg3-2, lower-roman) ". "
        }

        .lst-kix_2uqf52luwlch-3>li:before {
            content: "" counter(lst-ctn-kix_2uqf52luwlch-3, decimal) ". "
        }

        .lst-kix_2uqf52luwlch-5>li:before {
            content: "" counter(lst-ctn-kix_2uqf52luwlch-5, lower-roman) ". "
        }

        ol.lst-kix_ofi0mmcnclsi-2.start {
            counter-reset: lst-ctn-kix_ofi0mmcnclsi-2 0
        }

        .lst-kix_2uqf52luwlch-1>li:before {
            content: "" counter(lst-ctn-kix_2uqf52luwlch-1, lower-latin) ". "
        }

        .lst-kix_il2ghw7mpzg3-4>li:before {
            content: "" counter(lst-ctn-kix_il2ghw7mpzg3-4, lower-latin) ". "
        }

        .lst-kix_b10urs79we04-5>li {
            counter-increment: lst-ctn-kix_b10urs79we04-5
        }

        ol.lst-kix_j63ler45idng-7.start {
            counter-reset: lst-ctn-kix_j63ler45idng-7 0
        }

        ol.lst-kix_il2ghw7mpzg3-2.start {
            counter-reset: lst-ctn-kix_il2ghw7mpzg3-2 0
        }

        .lst-kix_rznbj4qtambp-3>li:before {
            content: "\\0025cf  "
        }

        .lst-kix_rznbj4qtambp-1>li:before {
            content: "\\0025cb  "
        }

        ol.lst-kix_2uqf52luwlch-6.start {
            counter-reset: lst-ctn-kix_2uqf52luwlch-6 0
        }

        .lst-kix_il2ghw7mpzg3-1>li {
            counter-increment: lst-ctn-kix_il2ghw7mpzg3-1
        }

        ol.lst-kix_ofi0mmcnclsi-3.start {
            counter-reset: lst-ctn-kix_ofi0mmcnclsi-3 0
        }

        .lst-kix_2uqf52luwlch-3>li {
            counter-increment: lst-ctn-kix_2uqf52luwlch-3
        }

        ol.lst-kix_26q3elmitsqj-6.start {
            counter-reset: lst-ctn-kix_26q3elmitsqj-6 0
        }

        ol.lst-kix_8svwjcre89oj-1.start {
            counter-reset: lst-ctn-kix_8svwjcre89oj-1 0
        }

        .lst-kix_il2ghw7mpzg3-7>li {
            counter-increment: lst-ctn-kix_il2ghw7mpzg3-7
        }

        .lst-kix_26q3elmitsqj-7>li:before {
            content: "" counter(lst-ctn-kix_26q3elmitsqj-7, lower-latin) ". "
        }

        .lst-kix_925qe2elwufe-8>li {
            counter-increment: lst-ctn-kix_925qe2elwufe-8
        }

        .lst-kix_j63ler45idng-4>li {
            counter-increment: lst-ctn-kix_j63ler45idng-4
        }

        .lst-kix_ofi0mmcnclsi-1>li {
            counter-increment: lst-ctn-kix_ofi0mmcnclsi-1
        }

        ol {
            margin: 0;
            padding: 0
        }

        table td,
        table th {
            padding: 0
        }

        .c7 {
            margin-left: 18pt;
            padding-top: 0pt;
            padding-left: 10.3pt;
            padding-bottom: 0pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify
        }

        .c8 {
            margin-left: 59.5pt;
            padding-top: 0pt;
            padding-left: 25.5pt;
            padding-bottom: 0pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify
        }

        .c5 {
            margin-left: 36pt;
            padding-top: 12pt;
            padding-left: 0pt;
            padding-bottom: 12pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: center
        }

        .c6 {
            margin-left: 53.4pt;
            padding-top: 0pt;
            padding-left: 24.5pt;
            padding-bottom: 0pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify
        }

        .c0 {
            margin-left: 72pt;
            padding-top: 12pt;
            padding-left: 0pt;
            padding-bottom: 12pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify
        }

        .c13 {
            margin-left: 99pt;
            padding-top: 0pt;
            padding-bottom: 0pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify
        }

        .c16 {
            color: #000000;
            font-weight: 700;
            text-decoration: none;
            vertical-align: baseline;
            font-size: 16pt;
            font-family: "Inter";
            font-style: normal
        }

        .c21 {
            color: #000000;
            font-weight: 700;
            text-decoration: none;
            vertical-align: baseline;
            font-size: 14pt;
            font-family: "Inter";
            font-style: normal
        }

        .c3 {
            color: #000000;
            font-weight: 700;
            text-decoration: none;
            vertical-align: baseline;
            font-size: 12pt;
            font-family: "Inter";
            font-style: normal
        }

        .c2 {
            color: #000000;
            font-weight: 400;
            text-decoration: none;
            vertical-align: baseline;
            font-size: 12pt;
            font-family: "Inter";
            font-style: normal
        }

        .c4 {
            padding-top: 0pt;
            padding-bottom: 0pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: left;
            height: 11pt
        }

        .c12 {
            padding-top: 0pt;
            padding-bottom: 0pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify;
            height: 11pt
        }

        .c34 {
            padding-top: 12pt;
            padding-bottom: 0pt;
            line-height: 1.0;
            orphans: 2;
            widows: 2;
            text-align: center
        }

        .c1 {
            padding-top: 12pt;
            padding-bottom: 0pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify
        }

        .c20 {
            padding-top: 12pt;
            padding-bottom: 12pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: center
        }

        .c15 {
            padding-top: 0pt;
            padding-bottom: 0pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify
        }

        .c26 {
            padding-top: 18pt;
            padding-bottom: 0pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: center
        }

        .c17 {
            padding-top: 0pt;
            padding-bottom: 0pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: center
        }

        .c9 {
            padding-top: 12pt;
            padding-bottom: 12pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify
        }

        .c23 {
            padding-top: 18pt;
            padding-bottom: 0pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify
        }

        .c14 {
            font-size: 12pt;
            font-family: "Inter";
            font-weight: 700
        }

        .c11 {
            background-color: #ffffff;
            max-width: 452.6pt;
            padding: 49.6pt 72pt 72pt 70.9pt
        }

        .c27 {
            font-size: 14pt;
            font-family: "Inter";
            font-weight: 700
        }

        .c19 {
            font-size: 12pt;
            font-family: "Inter";
            font-weight: 400
        }

        .c33 {
            background-color: #ffffff;
            font-size: 12pt;
            color: #333333
        }

        .c10 {
            padding: 0;
            margin: 0
        }

        .c22 {
            margin-left: 72pt;
            padding-left: 0pt
        }

        .c18 {
            margin-left: 67.6pt;
            padding-left: 24.5pt
        }

        .c29 {
            margin-left: 36pt
        }

        .c30 {
            margin-left: 106pt
        }

        .c25 {
            padding-left: 10.3pt
        }

        .c28 {
            height: 11pt
        }

        .c32 {
            margin-left: 28.3pt
        }

        .c31 {
            text-indent: 43pt
        }

        .c24 {
            margin-left: 18pt
        }

        .title {
            padding-top: 0pt;
            color: #000000;
            font-size: 26pt;
            padding-bottom: 3pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        .subtitle {
            padding-top: 0pt;
            color: #666666;
            font-size: 15pt;
            padding-bottom: 16pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        li {
            color: #000000;
            font-size: 11pt;
            font-family: "Arial"
        }

        p {
            margin: 0;
            color: #000000;
            font-size: 11pt;
            font-family: "Arial"
        }

        h1 {
            padding-top: 20pt;
            color: #000000;
            font-size: 20pt;
            padding-bottom: 6pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h2 {
            padding-top: 18pt;
            color: #000000;
            font-size: 16pt;
            padding-bottom: 6pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h3 {
            padding-top: 16pt;
            color: #434343;
            font-size: 14pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h4 {
            padding-top: 14pt;
            color: #666666;
            font-size: 12pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h5 {
            padding-top: 12pt;
            color: #666666;
            font-size: 11pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h6 {
            padding-top: 12pt;
            color: #666666;
            font-size: 11pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            font-style: italic;
            orphans: 2;
            widows: 2;
            text-align: left
        }
    </style>
</head>

<body class="c11">
    <p class="c20"><span class="c16">&#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1072; &#1082;&#1086;&#1085;&#1092;&#1080;&#1076;&#1077;&#1085;&#1094;&#1080;&#1072;&#1083;&#1100;&#1085;&#1086;&#1089;&#1090;&#1080; &#1089;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; &laquo;any.market&raquo;</span></p>
    <p
        class="c20"><span class="c2">&nbsp;</span></p>
        <p class="c9"><span class="c2">&#1053;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1080;&#1081; &#1076;&#1086;&#1082;&#1091;&#1084;&#1077;&#1085;&#1090;, &laquo;&#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1072; &#1082;&#1086;&#1085;&#1092;&#1080;&#1076;&#1077;&#1085;&#1094;&#1080;&#1072;&#1083;&#1100;&#1085;&#1086;&#1089;&#1090;&#1080;&raquo; (&#1076;&#1072;&#1083;&#1077;&#1077; &ndash; &#1087;&#1086; &#1090;&#1077;&#1082;&#1089;&#1090;&#1091; &ndash; &laquo;&#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1072;&raquo;), &#1087;&#1088;&#1077;&#1076;&#1089;&#1090;&#1072;&#1074;&#1083;&#1103;&#1077;&#1090; &#1089;&#1086;&#1073;&#1086;&#1081; &#1087;&#1088;&#1072;&#1074;&#1080;&#1083;&#1072; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1086;&#1081; &nbsp;&laquo;any.market&raquo; &#1074; &#1083;&#1080;&#1094;&#1077; &#1048;&#1085;&#1076;&#1080;&#1074;&#1080;&#1076;&#1091;&#1072;&#1083;&#1100;&#1085;&#1086;&#1075;&#1086; &#1087;&#1088;&#1077;&#1076;&#1087;&#1088;&#1080;&#1085;&#1080;&#1084;&#1072;&#1090;&#1077;&#1083;&#1103; &#1041;&#1088;&#1072;&#1094;&#1091;&#1085; &#1040;&#1085;&#1085;&#1099; &#1057;&#1077;&#1088;&#1075;&#1077;&#1077;&#1074;&#1085;&#1099; (&#1048;&#1053;&#1053; 616608081864, &#1054;&#1043;&#1056;&#1053;&#1048;&#1055; 320619600119490) (&#1076;&#1072;&#1083;&#1077;&#1077; &ndash; &#1054;&#1087;&#1077;&#1088;&#1072;&#1090;&#1086;&#1088;) &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080; &#1055;&#1086;&#1082;&#1091;&#1087;&#1072;&#1090;&#1077;&#1083;&#1103; (&#1044;&#1072;&#1083;&#1077;&#1077; &ndash; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100;), &#1082;&#1086;&#1090;&#1086;&#1088;&#1091;&#1102; &#1054;&#1087;&#1077;&#1088;&#1072;&#1090;&#1086;&#1088; &#1084;&#1086;&#1078;&#1077;&#1090; &#1087;&#1086;&#1083;&#1091;&#1095;&#1080;&#1090;&#1100; &#1086; &#1055;&#1086;&#1082;&#1091;&#1087;&#1072;&#1090;&#1077;&#1083;&#1077; &#1074;&#1086; &#1074;&#1088;&#1077;&#1084;&#1103; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1080;&#1084; &#1083;&#1102;&#1073;&#1086;&#1075;&#1086; &#1080;&#1079; &#1089;&#1072;&#1081;&#1090;&#1086;&#1074;, &#1089;&#1077;&#1088;&#1074;&#1080;&#1089;&#1086;&#1074;, &#1089;&#1083;&#1091;&#1078;&#1073;, &#1087;&#1088;&#1086;&#1075;&#1088;&#1072;&#1084;&#1084;, &#1087;&#1088;&#1086;&#1076;&#1091;&#1082;&#1090;&#1086;&#1074; &#1080;&#1083;&#1080; &#1091;&#1089;&#1083;&#1091;&#1075; &#1054;&#1087;&#1077;&#1088;&#1072;&#1090;&#1086;&#1088;&#1072; (&#1076;&#1072;&#1083;&#1077;&#1077; &ndash; &#1057;&#1072;&#1081;&#1090;) &#1080; &#1074; &#1093;&#1086;&#1076;&#1077; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1054;&#1087;&#1077;&#1088;&#1072;&#1090;&#1086;&#1088;&#1086;&#1084; &#1083;&#1102;&#1073;&#1099;&#1093; &#1089;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1081; &#1080; &#1076;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1086;&#1074; &#1089; &#1055;&#1086;&#1082;&#1091;&#1087;&#1072;&#1090;&#1077;&#1083;&#1077;&#1084;.</span></p>
        <p
            class="c15"><span class="c2">&#1048;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1077; &#1057;&#1072;&#1081;&#1090;&#1072; &#1086;&#1079;&#1085;&#1072;&#1095;&#1072;&#1077;&#1090; &#1073;&#1077;&#1079;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1086;&#1095;&#1085;&#1086;&#1077; &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1080;&#1077; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103; &#1089; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1081; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1086;&#1081; &#1080; &#1091;&#1082;&#1072;&#1079;&#1072;&#1085;&#1085;&#1099;&#1084;&#1080; &#1074; &#1085;&#1077;&#1081; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1103;&#1084;&#1080; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1080; &#1077;&#1075;&#1086; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080;; &#1074; &#1089;&#1083;&#1091;&#1095;&#1072;&#1077; &#1085;&#1077;&#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1080;&#1103; &#1089; &#1101;&#1090;&#1080;&#1084;&#1080; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1103;&#1084;&#1080; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100; &#1076;&#1086;&#1083;&#1078;&#1077;&#1085; &#1074;&#1086;&#1079;&#1076;&#1077;&#1088;&#1078;&#1072;&#1090;&#1100;&#1089;&#1103; &#1086;&#1090; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1057;&#1072;&#1081;&#1090;&#1072;.</span></p>
            <p
                class="c15 c31"><span class="c2">&nbsp;</span></p>
                <p class="c17 c28"><span class="c21"></span></p>
                <p class="c17"><span class="c27">&#1058;&#1077;&#1088;&#1084;&#1080;&#1085;&#1099;</span></p>
                <p class="c9"><span class="c14">&#1055;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1077; &#1076;&#1072;&#1085;&#1085;&#1099;&#1077;</span><span class="c2">&nbsp;- &#1083;&#1102;&#1073;&#1072;&#1103; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1103;, &#1086;&#1090;&#1085;&#1086;&#1089;&#1103;&#1097;&#1072;&#1103;&#1089;&#1103; &#1082; &#1087;&#1088;&#1103;&#1084;&#1086; &#1080;&#1083;&#1080; &#1082;&#1086;&#1089;&#1074;&#1077;&#1085;&#1085;&#1086; &#1086;&#1087;&#1088;&#1077;&#1076;&#1077;&#1083;&#1077;&#1085;&#1085;&#1086;&#1084;&#1091; &#1080;&#1083;&#1080; &#1086;&#1087;&#1088;&#1077;&#1076;&#1077;&#1083;&#1103;&#1077;&#1084;&#1086;&#1084;&#1091; &#1092;&#1080;&#1079;&#1080;&#1095;&#1077;&#1089;&#1082;&#1086;&#1084;&#1091; &#1083;&#1080;&#1094;&#1091; (&#1089;&#1091;&#1073;&#1098;&#1077;&#1082;&#1090;&#1091; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;).</span></p>
                <p
                    class="c9"><span class="c14">&#1054;&#1087;&#1077;&#1088;&#1072;&#1090;&#1086;&#1088; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093; (&#1086;&#1087;&#1077;&#1088;&#1072;&#1090;&#1086;&#1088;)</span>
                    <span
                        class="c2">&nbsp;- &#1075;&#1086;&#1089;&#1091;&#1076;&#1072;&#1088;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1099;&#1081; &#1086;&#1088;&#1075;&#1072;&#1085;, &#1084;&#1091;&#1085;&#1080;&#1094;&#1080;&#1087;&#1072;&#1083;&#1100;&#1085;&#1099;&#1081;
                        &#1086;&#1088;&#1075;&#1072;&#1085;, &#1102;&#1088;&#1080;&#1076;&#1080;&#1095;&#1077;&#1089;&#1082;&#1086;&#1077; &#1080;&#1083;&#1080; &#1092;&#1080;&#1079;&#1080;&#1095;&#1077;&#1089;&#1082;&#1086;&#1077; &#1083;&#1080;&#1094;&#1086;,
                        &#1089;&#1072;&#1084;&#1086;&#1089;&#1090;&#1086;&#1103;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086; &#1080;&#1083;&#1080; &#1089;&#1086;&#1074;&#1084;&#1077;&#1089;&#1090;&#1085;&#1086; &#1089; &#1076;&#1088;&#1091;&#1075;&#1080;&#1084;&#1080;
                        &#1083;&#1080;&#1094;&#1072;&#1084;&#1080; &#1086;&#1088;&#1075;&#1072;&#1085;&#1080;&#1079;&#1091;&#1102;&#1097;&#1080;&#1077; &#1080; (&#1080;&#1083;&#1080;) &#1086;&#1089;&#1091;&#1097;&#1077;&#1089;&#1090;&#1074;&#1083;&#1103;&#1102;&#1097;&#1080;&#1077;
                        &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1091; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;, &#1072; &#1090;&#1072;&#1082;&#1078;&#1077;
                        &#1086;&#1087;&#1088;&#1077;&#1076;&#1077;&#1083;&#1103;&#1102;&#1097;&#1080;&#1077; &#1094;&#1077;&#1083;&#1080; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1080; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093;
                        &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;, &#1089;&#1086;&#1089;&#1090;&#1072;&#1074; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;, &#1087;&#1086;&#1076;&#1083;&#1077;&#1078;&#1072;&#1097;&#1080;&#1093;
                        &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1077;, &#1076;&#1077;&#1081;&#1089;&#1090;&#1074;&#1080;&#1103; (&#1086;&#1087;&#1077;&#1088;&#1072;&#1094;&#1080;&#1080;), &#1089;&#1086;&#1074;&#1077;&#1088;&#1096;&#1072;&#1077;&#1084;&#1099;&#1077;
                        &#1089; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1084;&#1080; &#1076;&#1072;&#1085;&#1085;&#1099;&#1084;&#1080;.</span>
                        </p>
                        <p class="c9"><span class="c14">&#1054;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1072; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;</span><span class="c2">&nbsp;- &#1083;&#1102;&#1073;&#1086;&#1077; &#1076;&#1077;&#1081;&#1089;&#1090;&#1074;&#1080;&#1077; (&#1086;&#1087;&#1077;&#1088;&#1072;&#1094;&#1080;&#1103;) &#1080;&#1083;&#1080; &#1089;&#1086;&#1074;&#1086;&#1082;&#1091;&#1087;&#1085;&#1086;&#1089;&#1090;&#1100; &#1076;&#1077;&#1081;&#1089;&#1090;&#1074;&#1080;&#1081; (&#1086;&#1087;&#1077;&#1088;&#1072;&#1094;&#1080;&#1081;) &#1089; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1084;&#1080; &#1076;&#1072;&#1085;&#1085;&#1099;&#1084;&#1080;, &#1089;&#1086;&#1074;&#1077;&#1088;&#1096;&#1072;&#1077;&#1084;&#1099;&#1093; &#1089; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1077;&#1084; &#1089;&#1088;&#1077;&#1076;&#1089;&#1090;&#1074; &#1072;&#1074;&#1090;&#1086;&#1084;&#1072;&#1090;&#1080;&#1079;&#1072;&#1094;&#1080;&#1080; &#1080;&#1083;&#1080; &#1073;&#1077;&#1079; &#1080;&#1093; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103;. &#1054;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1072; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093; &#1074;&#1082;&#1083;&#1102;&#1095;&#1072;&#1077;&#1090; &#1074; &#1089;&#1077;&#1073;&#1103; &#1074; &#1090;&#1086;&#1084; &#1095;&#1080;&#1089;&#1083;&#1077;:</span></p>
                        <ul
                            class="c10 lst-kix_rznbj4qtambp-0 start">
                            <li class="c0"><span class="c2">&#1089;&#1073;&#1086;&#1088;;</span></li>
                            <li class="c0"><span class="c2">&#1079;&#1072;&#1087;&#1080;&#1089;&#1100;;</span></li>
                            <li class="c0"><span class="c2">&#1089;&#1080;&#1089;&#1090;&#1077;&#1084;&#1072;&#1090;&#1080;&#1079;&#1072;&#1094;&#1080;&#1102;;</span></li>
                            <li class="c0"><span class="c2">&#1085;&#1072;&#1082;&#1086;&#1087;&#1083;&#1077;&#1085;&#1080;&#1077;;</span></li>
                            <li class="c0"><span class="c2">&#1093;&#1088;&#1072;&#1085;&#1077;&#1085;&#1080;&#1077;;</span></li>
                            <li class="c0"><span class="c2">&#1091;&#1090;&#1086;&#1095;&#1085;&#1077;&#1085;&#1080;&#1077; (&#1086;&#1073;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1080;&#1077;, &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1077;);</span></li>
                            <li
                                class="c0"><span class="c2">&#1080;&#1079;&#1074;&#1083;&#1077;&#1095;&#1077;&#1085;&#1080;&#1077;;</span></li>
                                <li class="c0"><span class="c2">&#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1077;;</span></li>
                                <li class="c0"><span class="c2">&#1087;&#1077;&#1088;&#1077;&#1076;&#1072;&#1095;&#1091; (&#1088;&#1072;&#1089;&#1087;&#1088;&#1086;&#1089;&#1090;&#1088;&#1072;&#1085;&#1077;&#1085;&#1080;&#1077;, &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1080;&#1077;, &#1076;&#1086;&#1089;&#1090;&#1091;&#1087;);</span></li>
                                <li
                                    class="c0"><span class="c19">&#1086;&#1073;&#1077;&#1079;&#1083;&#1080;&#1095;&#1080;&#1074;&#1072;&#1085;&#1080;&#1077;</span><span class="c2">;</span></li>
                                    <li class="c0"><span class="c2">&#1073;&#1083;&#1086;&#1082;&#1080;&#1088;&#1086;&#1074;&#1072;&#1085;&#1080;&#1077;;</span></li>
                                    <li class="c0"><span class="c2">&#1091;&#1076;&#1072;&#1083;&#1077;&#1085;&#1080;&#1077;;</span></li>
                                    <li class="c0"><span class="c19">&#1091;&#1085;&#1080;&#1095;&#1090;&#1086;&#1078;&#1077;&#1085;&#1080;&#1077;;</span></li>
                                    </ul>
                                    <p class="c9"><span class="c14">&#1040;&#1074;&#1090;&#1086;&#1084;&#1072;&#1090;&#1080;&#1079;&#1080;&#1088;&#1086;&#1074;&#1072;&#1085;&#1085;&#1072;&#1103; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1072; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;</span>
                                        <span
                                            class="c2">&nbsp;- &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1072; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093; &#1089; &#1087;&#1086;&#1084;&#1086;&#1097;&#1100;&#1102;
                                            &#1089;&#1088;&#1077;&#1076;&#1089;&#1090;&#1074; &#1074;&#1099;&#1095;&#1080;&#1089;&#1083;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086;&#1081; &#1090;&#1077;&#1093;&#1085;&#1080;&#1082;&#1080;;</span>
                                    </p>
                                    <p class="c9"><span class="c14">&#1059;&#1085;&#1080;&#1095;&#1090;&#1086;&#1078;&#1077;&#1085;&#1080;&#1077; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;</span>
                                        <span
                                            class="c2">&nbsp;- &#1076;&#1077;&#1081;&#1089;&#1090;&#1074;&#1080;&#1103;, &#1074; &#1088;&#1077;&#1079;&#1091;&#1083;&#1100;&#1090;&#1072;&#1090;&#1077; &#1082;&#1086;&#1090;&#1086;&#1088;&#1099;&#1093; &#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1080;&#1090;&#1089;&#1103;
                                            &#1085;&#1077;&#1074;&#1086;&#1079;&#1084;&#1086;&#1078;&#1085;&#1099;&#1084; &#1074;&#1086;&#1089;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1080;&#1090;&#1100; &#1089;&#1086;&#1076;&#1077;&#1088;&#1078;&#1072;&#1085;&#1080;&#1077;
                                            &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093; &#1074; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1086;&#1085;&#1085;&#1086;&#1081;
                                            &#1089;&#1080;&#1089;&#1090;&#1077;&#1084;&#1077; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093; &#1080; (&#1080;&#1083;&#1080;)
                                            &#1074; &#1088;&#1077;&#1079;&#1091;&#1083;&#1100;&#1090;&#1072;&#1090;&#1077; &#1082;&#1086;&#1090;&#1086;&#1088;&#1099;&#1093; &#1091;&#1085;&#1080;&#1095;&#1090;&#1086;&#1078;&#1072;&#1102;&#1090;&#1089;&#1103;
                                            &#1084;&#1072;&#1090;&#1077;&#1088;&#1080;&#1072;&#1083;&#1100;&#1085;&#1099;&#1077; &#1085;&#1086;&#1089;&#1080;&#1090;&#1077;&#1083;&#1080; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093;
                                            &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;;</span>
                                    </p>
                                    <p class="c15"><span class="c14">&#1058;&#1088;&#1072;&#1085;&#1089;&#1075;&#1088;&#1072;&#1085;&#1080;&#1095;&#1085;&#1072;&#1103; &#1087;&#1077;&#1088;&#1077;&#1076;&#1072;&#1095;&#1072; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;</span>
                                        <span
                                            class="c2">&nbsp;- &#1087;&#1077;&#1088;&#1077;&#1076;&#1072;&#1095;&#1072; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093; &#1085;&#1072; &#1090;&#1077;&#1088;&#1088;&#1080;&#1090;&#1086;&#1088;&#1080;&#1102;
                                            &#1080;&#1085;&#1086;&#1089;&#1090;&#1088;&#1072;&#1085;&#1085;&#1086;&#1075;&#1086; &#1075;&#1086;&#1089;&#1091;&#1076;&#1072;&#1088;&#1089;&#1090;&#1074;&#1072; &#1086;&#1088;&#1075;&#1072;&#1085;&#1091; &#1074;&#1083;&#1072;&#1089;&#1090;&#1080;
                                            &#1080;&#1085;&#1086;&#1089;&#1090;&#1088;&#1072;&#1085;&#1085;&#1086;&#1075;&#1086; &#1075;&#1086;&#1089;&#1091;&#1076;&#1072;&#1088;&#1089;&#1090;&#1074;&#1072;, &#1080;&#1085;&#1086;&#1089;&#1090;&#1088;&#1072;&#1085;&#1085;&#1086;&#1084;&#1091;
                                            &#1092;&#1080;&#1079;&#1080;&#1095;&#1077;&#1089;&#1082;&#1086;&#1084;&#1091; &#1083;&#1080;&#1094;&#1091; &#1080;&#1083;&#1080; &#1080;&#1085;&#1086;&#1089;&#1090;&#1088;&#1072;&#1085;&#1085;&#1086;&#1084;&#1091;
                                            &#1102;&#1088;&#1080;&#1076;&#1080;&#1095;&#1077;&#1089;&#1082;&#1086;&#1084;&#1091; &#1083;&#1080;&#1094;&#1091;.</span>
                                    </p>
                                    <p class="c12"><span class="c3"></span></p>
                                    <ol class="c10 lst-kix_ofi0mmcnclsi-0 start" start="1">
                                        <li class="c5"><span class="c21">&#1054;&#1073;&#1097;&#1080;&#1077; &#1087;&#1086;&#1083;&#1086;&#1078;&#1077;&#1085;&#1080;&#1103; &#1087;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1080;</span></li>
                                    </ol>
                                    <p class="c20 c28 c29"><span class="c21"></span></p>
                                    <ol class="c10 lst-kix_9c69ktmkhots-0 start" start="1">
                                        <li class="c9 c25 c24"><span class="c2">&#1053;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1072;&#1103; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1072; &#1103;&#1074;&#1083;&#1103;&#1077;&#1090;&#1089;&#1103; &#1085;&#1077;&#1086;&#1090;&#1098;&#1077;&#1084;&#1083;&#1077;&#1084;&#1086;&#1081; &#1095;&#1072;&#1089;&#1090;&#1100;&#1102; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1082;&#1086;&#1075;&#1086; &#1089;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103; &#1089;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; any.market (&#1076;&#1072;&#1083;&#1077;&#1077; &ndash; &laquo;&#1054;&#1092;&#1077;&#1088;&#1090;&#1072;&raquo;), &#1088;&#1072;&#1079;&#1084;&#1077;&#1097;&#1077;&#1085;&#1085;&#1086;&#1081; &#1080;/&#1080;&#1083;&#1080; &#1076;&#1086;&#1089;&#1090;&#1091;&#1087;&#1085;&#1086;&#1081; &#1074; &#1089;&#1077;&#1090;&#1080; &#1048;&#1085;&#1090;&#1077;&#1088;&#1085;&#1077;&#1090; &#1087;&#1086; &#1072;&#1076;&#1088;&#1077;&#1089;&#1091;: https://any.market/legal, &#1072; &#1090;&#1072;&#1082;&#1078;&#1077; &#1080;&#1085;&#1099;&#1093; &#1079;&#1072;&#1082;&#1083;&#1102;&#1095;&#1072;&#1077;&#1084;&#1099;&#1093; &#1089; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1084; &#1076;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1086;&#1074;, &#1082;&#1086;&#1075;&#1076;&#1072; &#1101;&#1090;&#1086; &#1087;&#1088;&#1103;&#1084;&#1086; &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1086; &#1080;&#1093; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1103;&#1084;&#1080;.</span></li>
                                        <li
                                            class="c7"><span class="c2">&#1053;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1072;&#1103; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1072; &#1089;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1072; &#1074; &#1089;&#1086;&#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1080;&#1080; &#1089; &#1060;&#1077;&#1076;&#1077;&#1088;&#1072;&#1083;&#1100;&#1085;&#1099;&#1084; &#1079;&#1072;&#1082;&#1086;&#1085;&#1086;&#1084; &laquo;&#1054; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;&raquo; &#8470; 152-&#1060;&#1047; &#1086;&#1090; 27 &#1080;&#1102;&#1083;&#1103; 2006 &#1075;., &#1072; &#1090;&#1072;&#1082;&#1078;&#1077; &#1080;&#1085;&#1099;&#1084;&#1080; &#1085;&#1086;&#1088;&#1084;&#1072;&#1090;&#1080;&#1074;&#1085;&#1086;-&#1087;&#1088;&#1072;&#1074;&#1086;&#1074;&#1099;&#1084;&#1080; &#1072;&#1082;&#1090;&#1072;&#1084;&#1080; &#1056;&#1086;&#1089;&#1089;&#1080;&#1081;&#1089;&#1082;&#1086;&#1081; &#1060;&#1077;&#1076;&#1077;&#1088;&#1072;&#1094;&#1080;&#1080; &#1074; &#1086;&#1073;&#1083;&#1072;&#1089;&#1090;&#1080; &#1079;&#1072;&#1097;&#1080;&#1090;&#1099; &#1080; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1080; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093; &#1080; &#1076;&#1077;&#1081;&#1089;&#1090;&#1074;&#1091;&#1077;&#1090; &#1074; &#1086;&#1090;&#1085;&#1086;&#1096;&#1077;&#1085;&#1080;&#1080; &#1074;&#1089;&#1077;&#1093; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;, &#1082;&#1086;&#1090;&#1086;&#1088;&#1099;&#1077; &#1054;&#1087;&#1077;&#1088;&#1072;&#1090;&#1086;&#1088; &#1084;&#1086;&#1078;&#1077;&#1090; &#1087;&#1086;&#1083;&#1091;&#1095;&#1080;&#1090;&#1100; &#1086;&#1090; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103;, &#1103;&#1074;&#1083;&#1103;&#1102;&#1097;&#1077;&#1075;&#1086;&#1089;&#1103; &#1089;&#1090;&#1086;&#1088;&#1086;&#1085;&#1086;&#1081; &#1087;&#1086; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1082;&#1086;&#1084;&#1091; &#1089;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1102;.</span></li>
                                            <li
                                                class="c7"><span class="c2">&#1054;&#1087;&#1077;&#1088;&#1072;&#1090;&#1086;&#1088; &#1080;&#1084;&#1077;&#1077;&#1090; &#1087;&#1088;&#1072;&#1074;&#1086; &#1074;&#1085;&#1086;&#1089;&#1080;&#1090;&#1100; &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1103; &#1074; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1091;&#1102; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1091;. &#1055;&#1088;&#1080; &#1074;&#1085;&#1077;&#1089;&#1077;&#1085;&#1080;&#1080; &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1081; &#1074; &#1079;&#1072;&#1075;&#1086;&#1083;&#1086;&#1074;&#1082;&#1077; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1080; &#1091;&#1082;&#1072;&#1079;&#1099;&#1074;&#1072;&#1077;&#1090;&#1089;&#1103; &#1076;&#1072;&#1090;&#1072; &#1087;&#1086;&#1089;&#1083;&#1077;&#1076;&#1085;&#1077;&#1075;&#1086; &#1086;&#1073;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103; &#1088;&#1077;&#1076;&#1072;&#1082;&#1094;&#1080;&#1080;. &#1053;&#1086;&#1074;&#1072;&#1103; &#1088;&#1077;&#1076;&#1072;&#1082;&#1094;&#1080;&#1103; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1080; &#1074;&#1089;&#1090;&#1091;&#1087;&#1072;&#1077;&#1090; &#1074; &#1089;&#1080;&#1083;&#1091; &#1089; &#1084;&#1086;&#1084;&#1077;&#1085;&#1090;&#1072; &#1077;&#1077; &#1088;&#1072;&#1079;&#1084;&#1077;&#1097;&#1077;&#1085;&#1080;&#1103; &#1085;&#1072; &#1089;&#1072;&#1081;&#1090;&#1077;, &#1077;&#1089;&#1083;&#1080; &#1080;&#1085;&#1086;&#1077; &#1085;&#1077; &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1086; &#1085;&#1086;&#1074;&#1086;&#1081; &#1088;&#1077;&#1076;&#1072;&#1082;&#1094;&#1080;&#1077;&#1081; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1080;.</span></li>
                                                <li
                                                    class="c7"><span class="c2">&#1050; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1081; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1077;, &#1074;&#1082;&#1083;&#1102;&#1095;&#1072;&#1103; &#1090;&#1086;&#1083;&#1082;&#1086;&#1074;&#1072;&#1085;&#1080;&#1077; &#1077;&#1077; &#1087;&#1086;&#1083;&#1086;&#1078;&#1077;&#1085;&#1080;&#1081; &#1080; &#1087;&#1086;&#1088;&#1103;&#1076;&#1086;&#1082; &#1087;&#1088;&#1080;&#1085;&#1103;&#1090;&#1080;&#1103;, &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103;, &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1103; &#1080; &#1087;&#1088;&#1077;&#1082;&#1088;&#1072;&#1097;&#1077;&#1085;&#1080;&#1103;, &#1087;&#1086;&#1076;&#1083;&#1077;&#1078;&#1080;&#1090; &#1087;&#1088;&#1080;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1102; &#1079;&#1072;&#1082;&#1086;&#1085;&#1086;&#1076;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;&#1086; &#1056;&#1086;&#1089;&#1089;&#1080;&#1081;&#1089;&#1082;&#1086;&#1081; &#1060;&#1077;&#1076;&#1077;&#1088;&#1072;&#1094;&#1080;&#1080;.</span></li>
                                    </ol>
                                    <p class="c12 c32"><span class="c2"></span></p>
                                    <p class="c34"><span class="c14">&nbsp;</span><span class="c21">2. &#1055;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1072;&#1103; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1103; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1081;, &#1086;&#1073;&#1088;&#1072;&#1073;&#1072;&#1090;&#1099;&#1074;&#1072;&#1077;&#1084;&#1072;&#1103; &#1057;&#1072;&#1081;&#1090;&#1086;&#1084;</span></p>
                                    <ol
                                        class="c10 lst-kix_26q3elmitsqj-0 start" start="1">
                                        <li class="c1 c25 c24"><span class="c2">&#1055;&#1086;&#1076; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1077;&#1081; &#1074; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1081; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1077; &#1087;&#1086;&#1085;&#1080;&#1084;&#1072;&#1077;&#1090;&#1089;&#1103;:</span></li>
                                        </ol>
                                        <ol class="c10 lst-kix_26q3elmitsqj-1 start" start="1">
                                            <li class="c6"><span class="c2">&#1048;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1103;, &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1103;&#1077;&#1084;&#1072;&#1103; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1084; &#1089;&#1072;&#1084;&#1086;&#1089;&#1090;&#1086;&#1103;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086; &#1087;&#1088;&#1080; &#1088;&#1077;&#1075;&#1080;&#1089;&#1090;&#1088;&#1072;&#1094;&#1080;&#1080; (&#1089;&#1086;&#1079;&#1076;&#1072;&#1085;&#1080;&#1080; &#1091;&#1095;&#1105;&#1090;&#1085;&#1086;&#1081; &#1079;&#1072;&#1087;&#1080;&#1089;&#1080;) &#1080;&#1083;&#1080; &#1074; &#1087;&#1088;&#1086;&#1094;&#1077;&#1089;&#1089;&#1077; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1057;&#1072;&#1081;&#1090;&#1072;, &#1074;&#1082;&#1083;&#1102;&#1095;&#1072;&#1103; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1077; &#1076;&#1072;&#1085;&#1085;&#1099;&#1077; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103;. &#1054;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1085;&#1072;&#1103; &#1076;&#1083;&#1103; &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103; &#1057;&#1072;&#1081;&#1090;&#1086;&#1084; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1103; &#1087;&#1086;&#1084;&#1077;&#1095;&#1077;&#1085;&#1072; &#1089;&#1087;&#1077;&#1094;&#1080;&#1072;&#1083;&#1100;&#1085;&#1099;&#1084; &#1086;&#1073;&#1088;&#1072;&#1079;&#1086;&#1084;. &#1048;&#1085;&#1072;&#1103; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1103; &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1103;&#1077;&#1090;&#1089;&#1103; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1084; &#1085;&#1072; &#1077;&#1075;&#1086; &#1091;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1080;&#1077;;</span></li>
                                            <li
                                                class="c6"><span class="c2">&#1044;&#1072;&#1085;&#1085;&#1099;&#1077;, &#1082;&#1086;&#1090;&#1086;&#1088;&#1099;&#1077; &#1087;&#1077;&#1088;&#1077;&#1076;&#1072;&#1102;&#1090;&#1089;&#1103; &#1074; &#1072;&#1074;&#1090;&#1086;&#1084;&#1072;&#1090;&#1080;&#1095;&#1077;&#1089;&#1082;&#1086;&#1084; &#1088;&#1077;&#1078;&#1080;&#1084;&#1077; &#1057;&#1072;&#1081;&#1090;&#1091; &#1074; &#1087;&#1088;&#1086;&#1094;&#1077;&#1089;&#1089;&#1077; &#1080;&#1093; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1089; &#1087;&#1086;&#1084;&#1086;&#1097;&#1100;&#1102; &#1091;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1085;&#1086;&#1075;&#1086; &#1085;&#1072; &#1091;&#1089;&#1090;&#1088;&#1086;&#1081;&#1089;&#1090;&#1074;&#1077; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103; &#1087;&#1088;&#1086;&#1075;&#1088;&#1072;&#1084;&#1084;&#1085;&#1086;&#1075;&#1086; &#1086;&#1073;&#1077;&#1089;&#1087;&#1077;&#1095;&#1077;&#1085;&#1080;&#1103;, &#1074; &#1090;&#1086;&#1084; &#1095;&#1080;&#1089;&#1083;&#1077; IP-&#1072;&#1076;&#1088;&#1077;&#1089;, &#1076;&#1072;&#1085;&#1085;&#1099;&#1077; &#1092;&#1072;&#1081;&#1083;&#1086;&#1074; cookie, &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1103; &#1086; &#1073;&#1088;&#1072;&#1091;&#1079;&#1077;&#1088;&#1077; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103; (&#1080;&#1083;&#1080; &#1080;&#1085;&#1086;&#1081; &#1087;&#1088;&#1086;&#1075;&#1088;&#1072;&#1084;&#1084;&#1077;, &#1089; &#1087;&#1086;&#1084;&#1086;&#1097;&#1100;&#1102; &#1082;&#1086;&#1090;&#1086;&#1088;&#1086;&#1081; &#1086;&#1089;&#1091;&#1097;&#1077;&#1089;&#1090;&#1074;&#1083;&#1103;&#1077;&#1090;&#1089;&#1103; &#1076;&#1086;&#1089;&#1090;&#1091;&#1087; &#1082; &#1057;&#1072;&#1081;&#1090;&#1091;), &#1090;&#1077;&#1093;&#1085;&#1080;&#1095;&#1077;&#1089;&#1082;&#1080;&#1077; &#1093;&#1072;&#1088;&#1072;&#1082;&#1090;&#1077;&#1088;&#1080;&#1089;&#1090;&#1080;&#1082;&#1080; &#1086;&#1073;&#1086;&#1088;&#1091;&#1076;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1080; &#1087;&#1088;&#1086;&#1075;&#1088;&#1072;&#1084;&#1084;&#1085;&#1086;&#1075;&#1086; &#1086;&#1073;&#1077;&#1089;&#1087;&#1077;&#1095;&#1077;&#1085;&#1080;&#1103;, &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1091;&#1077;&#1084;&#1099;&#1093; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1084;, &#1076;&#1072;&#1090;&#1072; &#1080; &#1074;&#1088;&#1077;&#1084;&#1103; &#1076;&#1086;&#1089;&#1090;&#1091;&#1087;&#1072; &#1082; &#1057;&#1072;&#1081;&#1090;&#1091;, &#1072;&#1076;&#1088;&#1077;&#1089;&#1072; &#1079;&#1072;&#1087;&#1088;&#1072;&#1096;&#1080;&#1074;&#1072;&#1077;&#1084;&#1099;&#1093; &#1089;&#1090;&#1088;&#1072;&#1085;&#1080;&#1094; &#1080; &#1080;&#1085;&#1072;&#1103; &#1087;&#1086;&#1076;&#1086;&#1073;&#1085;&#1072;&#1103; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1103;;</span></li>
                                        </ol>
                                        <ol class="c10 lst-kix_26q3elmitsqj-0" start="2">
                                            <li class="c7"><span class="c2">&#1048;&#1085;&#1072;&#1103; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1103; &#1086; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;, &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1072; &#1082;&#1086;&#1090;&#1086;&#1088;&#1086;&#1081; &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1072; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1103;&#1084;&#1080; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1057;&#1072;&#1081;&#1090;&#1072;.</span></li>
                                            <li
                                                class="c7"><span class="c2">&#1053;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1072;&#1103; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1072; &#1087;&#1088;&#1080;&#1084;&#1077;&#1085;&#1080;&#1084;&#1072; &#1090;&#1086;&#1083;&#1100;&#1082;&#1086; &#1082; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080;, &#1086;&#1073;&#1088;&#1072;&#1073;&#1072;&#1090;&#1099;&#1074;&#1072;&#1077;&#1084;&#1086;&#1081; &#1074; &#1093;&#1086;&#1076;&#1077; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1057;&#1072;&#1081;&#1090;&#1072;. &#1057;&#1072;&#1081;&#1090; &#1085;&#1077; &#1082;&#1086;&#1085;&#1090;&#1088;&#1086;&#1083;&#1080;&#1088;&#1091;&#1077;&#1090; &#1080; &#1085;&#1077; &#1085;&#1077;&#1089;&#1077;&#1090; &#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1086;&#1089;&#1090;&#1100; &#1079;&#1072; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1091; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080; &#1089;&#1072;&#1081;&#1090;&#1072;&#1084;&#1080; &#1090;&#1088;&#1077;&#1090;&#1100;&#1080;&#1093; &#1083;&#1080;&#1094;, &#1085;&#1072; &#1082;&#1086;&#1090;&#1086;&#1088;&#1099;&#1077; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100; &#1084;&#1086;&#1078;&#1077;&#1090; &#1087;&#1077;&#1088;&#1077;&#1081;&#1090;&#1080; &#1087;&#1086; &#1089;&#1089;&#1099;&#1083;&#1082;&#1072;&#1084;, &#1076;&#1086;&#1089;&#1090;&#1091;&#1087;&#1085;&#1099;&#1084; &#1085;&#1072; &#1057;&#1072;&#1081;&#1090;&#1077;.</span></li>
                                                <li
                                                    class="c7"><span class="c2">&#1057;&#1072;&#1081;&#1090; &#1085;&#1077; &#1087;&#1088;&#1086;&#1074;&#1077;&#1088;&#1103;&#1077;&#1090; &#1076;&#1086;&#1089;&#1090;&#1086;&#1074;&#1077;&#1088;&#1085;&#1086;&#1089;&#1090;&#1100; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080;, &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1103;&#1077;&#1084;&#1086;&#1081; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1084;, &#1080; &#1085;&#1077; &#1080;&#1084;&#1077;&#1077;&#1090; &#1074;&#1086;&#1079;&#1084;&#1086;&#1078;&#1085;&#1086;&#1089;&#1090;&#1080; &#1086;&#1094;&#1077;&#1085;&#1080;&#1074;&#1072;&#1090;&#1100; &#1077;&#1075;&#1086; &#1076;&#1077;&#1077;&#1089;&#1087;&#1086;&#1089;&#1086;&#1073;&#1085;&#1086;&#1089;&#1090;&#1100;.</span></li>
                                        </ol>
                                        <p class="c15"><span class="c2">&nbsp;</span></p>
                                        <p class="c12"><span class="c2"></span></p>
                                        <p class="c17"><span class="c21">3. &#1062;&#1077;&#1083;&#1080; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1080; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1081;</span></p>
                                        <p
                                            class="c15 c30"><span class="c3">&nbsp;</span></p>
                                            <ol class="c10 lst-kix_fa857d9azgn-0 start" start="1">
                                                <li class="c7"><span class="c2">&#1057;&#1072;&#1081;&#1090; &#1089;&#1086;&#1073;&#1080;&#1088;&#1072;&#1077;&#1090; &#1080; &#1093;&#1088;&#1072;&#1085;&#1080;&#1090; &#1090;&#1086;&#1083;&#1100;&#1082;&#1086; &#1090;&#1091; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1091;&#1102; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1102;, &#1082;&#1086;&#1090;&#1086;&#1088;&#1072;&#1103; &#1085;&#1077;&#1086;&#1073;&#1093;&#1086;&#1076;&#1080;&#1084;&#1072; &#1076;&#1083;&#1103; &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103; &#1089;&#1077;&#1088;&#1074;&#1080;&#1089;&#1086;&#1074; &#1080;&#1083;&#1080; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1089;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1081; &#1080; &#1076;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1086;&#1074; &#1089; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1084;, &#1079;&#1072; &#1080;&#1089;&#1082;&#1083;&#1102;&#1095;&#1077;&#1085;&#1080;&#1077;&#1084; &#1089;&#1083;&#1091;&#1095;&#1072;&#1077;&#1074;, &#1082;&#1086;&#1075;&#1076;&#1072; &#1079;&#1072;&#1082;&#1086;&#1085;&#1086;&#1076;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;&#1086;&#1084; &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1086; &#1086;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086;&#1077; &#1093;&#1088;&#1072;&#1085;&#1077;&#1085;&#1080;&#1077; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080; &#1074; &#1090;&#1077;&#1095;&#1077;&#1085;&#1080;&#1077; &#1086;&#1087;&#1088;&#1077;&#1076;&#1077;&#1083;&#1077;&#1085;&#1085;&#1086;&#1075;&#1086; &#1079;&#1072;&#1082;&#1086;&#1085;&#1086;&#1084; &#1089;&#1088;&#1086;&#1082;&#1072;.</span></li>
                                                <li
                                                    class="c7"><span class="c2">&#1055;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1091;&#1102; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1102; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103; &#1057;&#1072;&#1081;&#1090; &#1086;&#1073;&#1088;&#1072;&#1073;&#1072;&#1090;&#1099;&#1074;&#1072;&#1077;&#1090; &#1074; &#1089;&#1083;&#1077;&#1076;&#1091;&#1102;&#1097;&#1080;&#1093; &#1094;&#1077;&#1083;&#1103;&#1093;:</span></li>
                                            </ol>
                                            <ol class="c10 lst-kix_fa857d9azgn-1 start" start="1">
                                                <li class="c8"><span class="c2">&#1080;&#1076;&#1077;&#1085;&#1090;&#1080;&#1092;&#1080;&#1082;&#1072;&#1094;&#1080;&#1103; &#1089;&#1090;&#1086;&#1088;&#1086;&#1085;&#1099; &#1074; &#1088;&#1072;&#1084;&#1082;&#1072;&#1093; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1082;&#1086;&#1075;&#1086; &#1089;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103;;</span></li>
                                                <li
                                                    class="c8"><span class="c2">&#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1080;&#1077; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1102; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1080;&#1079;&#1080;&#1088;&#1086;&#1074;&#1072;&#1085;&#1085;&#1099;&#1093; &#1089;&#1077;&#1088;&#1074;&#1080;&#1089;&#1086;&#1074; &#1080; &#1091;&#1089;&#1083;&#1091;&#1075;, &#1072; &#1090;&#1072;&#1082;&#1078;&#1077; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1077; &#1089;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1081; &#1080; &#1076;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1086;&#1074;;</span></li>
                                                    <li
                                                        class="c8"><span class="c2">&#1085;&#1072;&#1087;&#1088;&#1072;&#1074;&#1083;&#1077;&#1085;&#1080;&#1077; &#1091;&#1074;&#1077;&#1076;&#1086;&#1084;&#1083;&#1077;&#1085;&#1080;&#1081;, &#1079;&#1072;&#1087;&#1088;&#1086;&#1089;&#1086;&#1074; &#1080; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080;, &#1082;&#1072;&#1089;&#1072;&#1102;&#1097;&#1080;&#1093;&#1089;&#1103; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1057;&#1072;&#1081;&#1090;&#1072;, &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1089;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1081; &#1080; &#1076;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1086;&#1074;, &#1072; &#1090;&#1072;&#1082;&#1078;&#1077; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1072; &#1079;&#1072;&#1087;&#1088;&#1086;&#1089;&#1086;&#1074; &#1080; &#1079;&#1072;&#1103;&#1074;&#1086;&#1082; &#1086;&#1090; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103;;</span></li>
                                                        <li
                                                            class="c8"><span class="c2">&#1091;&#1083;&#1091;&#1095;&#1096;&#1077;&#1085;&#1080;&#1077; &#1082;&#1072;&#1095;&#1077;&#1089;&#1090;&#1074;&#1072; &#1088;&#1072;&#1073;&#1086;&#1090;&#1099; &#1057;&#1072;&#1081;&#1090;&#1072;, &#1091;&#1076;&#1086;&#1073;&#1089;&#1090;&#1074;&#1072; &#1077;&#1075;&#1086; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1076;&#1083;&#1103; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103;, &#1088;&#1072;&#1079;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1072; &#1085;&#1086;&#1074;&#1099;&#1093; &#1091;&#1089;&#1083;&#1091;&#1075; &#1080; &#1089;&#1077;&#1088;&#1074;&#1080;&#1089;&#1086;&#1074;;</span></li>
                                                            <li
                                                                class="c8"><span class="c2">&#1090;&#1072;&#1088;&#1075;&#1077;&#1090;&#1080;&#1088;&#1086;&#1074;&#1072;&#1085;&#1080;&#1077; &#1088;&#1077;&#1082;&#1083;&#1072;&#1084;&#1085;&#1099;&#1093; &#1084;&#1072;&#1090;&#1077;&#1088;&#1080;&#1072;&#1083;&#1086;&#1074;;</span></li>
                                                                <li
                                                                    class="c8"><span class="c2">&#1087;&#1088;&#1086;&#1074;&#1077;&#1076;&#1077;&#1085;&#1080;&#1077; &#1089;&#1090;&#1072;&#1090;&#1080;&#1089;&#1090;&#1080;&#1095;&#1077;&#1089;&#1082;&#1080;&#1093; &#1080; &#1080;&#1085;&#1099;&#1093; &#1080;&#1089;&#1089;&#1083;&#1077;&#1076;&#1086;&#1074;&#1072;&#1085;&#1080;&#1081; &#1085;&#1072; &#1086;&#1089;&#1085;&#1086;&#1074;&#1077; &#1086;&#1073;&#1077;&#1079;&#1083;&#1080;&#1095;&#1077;&#1085;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;.</span></li>
                                            </ol>
                                            <p class="c15"><span class="c2">&nbsp;</span></p>
                                            <h2 class="c26" id="h.ho7uxyg8555q"><span class="c21">4. &#1059;&#1089;&#1083;&#1086;&#1074;&#1080;&#1103; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1080; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1081; &#1080; &#1087;&#1077;&#1088;&#1077;&#1076;&#1072;&#1095;&#1080; &#1090;&#1088;&#1077;&#1090;&#1100;&#1080;&#1084; &#1083;&#1080;&#1094;&#1072;&#1084;</span></h2>
                                            <ol
                                                class="c10 lst-kix_925qe2elwufe-0 start" start="1">
                                                <li class="c9 c24 c25"><span class="c2">&#1042; &#1086;&#1090;&#1085;&#1086;&#1096;&#1077;&#1085;&#1080;&#1080; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103; &#1089;&#1086;&#1093;&#1088;&#1072;&#1085;&#1103;&#1077;&#1090;&#1089;&#1103; &#1077;&#1077; &#1082;&#1086;&#1085;&#1092;&#1080;&#1076;&#1077;&#1085;&#1094;&#1080;&#1072;&#1083;&#1100;&#1085;&#1086;&#1089;&#1090;&#1100;, &#1082;&#1088;&#1086;&#1084;&#1077; &#1089;&#1083;&#1091;&#1095;&#1072;&#1077;&#1074; &#1076;&#1086;&#1073;&#1088;&#1086;&#1074;&#1086;&#1083;&#1100;&#1085;&#1086;&#1075;&#1086; &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1084; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080; &#1086; &#1089;&#1077;&#1073;&#1077; &#1076;&#1083;&#1103; &#1086;&#1073;&#1097;&#1077;&#1075;&#1086; &#1076;&#1086;&#1089;&#1090;&#1091;&#1087;&#1072; &#1085;&#1077;&#1086;&#1075;&#1088;&#1072;&#1085;&#1080;&#1095;&#1077;&#1085;&#1085;&#1086;&#1084;&#1091; &#1082;&#1088;&#1091;&#1075;&#1091; &#1083;&#1080;&#1094;.</span></li>
                                                <li
                                                    class="c23 c25 c24">
                                                    <h2 id="h.wwspmbupwqei" style="display:inline"><span class="c2">&#1057;&#1072;&#1081;&#1090; &#1074;&#1087;&#1088;&#1072;&#1074;&#1077; &#1087;&#1077;&#1088;&#1077;&#1076;&#1072;&#1090;&#1100; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1091;&#1102; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1102; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103; &#1090;&#1088;&#1077;&#1090;&#1100;&#1080;&#1084; &#1083;&#1080;&#1094;&#1072;&#1084; &#1074; &#1089;&#1083;&#1077;&#1076;&#1091;&#1102;&#1097;&#1080;&#1093; &#1089;&#1083;&#1091;&#1095;&#1072;&#1103;&#1093;:</span></h2>
                                                    </li>
                                                    </ol>
                                                    <ol class="c10 lst-kix_925qe2elwufe-1 start" start="1">
                                                        <li class="c23 c18">
                                                            <h2 id="h.u89nocu91os1" style="display:inline"><span class="c2">&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100; &#1074;&#1099;&#1088;&#1072;&#1079;&#1080;&#1083; &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1080;&#1077; &#1085;&#1072; &#1090;&#1072;&#1082;&#1080;&#1077; &#1076;&#1077;&#1081;&#1089;&#1090;&#1074;&#1080;&#1103;;</span></h2>
                                                        </li>
                                                        <li class="c23 c18">
                                                            <h2 id="h.2iq3kl3jte5o" style="display:inline"><span class="c2">&#1087;&#1077;&#1088;&#1077;&#1076;&#1072;&#1095;&#1072; &#1085;&#1077;&#1086;&#1073;&#1093;&#1086;&#1076;&#1080;&#1084;&#1072; &#1076;&#1083;&#1103; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1084; &#1086;&#1087;&#1088;&#1077;&#1076;&#1077;&#1083;&#1077;&#1085;&#1085;&#1086;&#1075;&#1086; &#1089;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; &#1083;&#1080;&#1073;&#1086; &#1076;&#1083;&#1103; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1086;&#1087;&#1088;&#1077;&#1076;&#1077;&#1083;&#1077;&#1085;&#1085;&#1086;&#1075;&#1086; &#1089;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103; &#1080;&#1083;&#1080; &#1076;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1072; &#1089; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1084;;</span></h2>
                                                        </li>
                                                        <li class="c23 c18">
                                                            <h2 id="h.g8olr0y5q4lh" style="display:inline"><span class="c2">&#1087;&#1077;&#1088;&#1077;&#1076;&#1072;&#1095;&#1072; &#1085;&#1077;&#1086;&#1073;&#1093;&#1086;&#1076;&#1080;&#1084;&#1072; &#1076;&#1083;&#1103; &#1092;&#1091;&#1085;&#1082;&#1094;&#1080;&#1086;&#1085;&#1080;&#1088;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1080; &#1088;&#1072;&#1073;&#1086;&#1090;&#1086;&#1089;&#1087;&#1086;&#1089;&#1086;&#1073;&#1085;&#1086;&#1089;&#1090;&#1080; &#1089;&#1072;&#1084;&#1086;&#1075;&#1086; &#1057;&#1072;&#1081;&#1090;&#1072;;</span></h2>
                                                        </li>
                                                        <li class="c18 c23">
                                                            <h2 id="h.w0nudwpfkxto" style="display:inline"><span class="c2">&#1087;&#1077;&#1088;&#1077;&#1076;&#1072;&#1095;&#1072; &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1072; &#1088;&#1086;&#1089;&#1089;&#1080;&#1081;&#1089;&#1082;&#1080;&#1084; &#1080;&#1083;&#1080; &#1080;&#1085;&#1099;&#1084; &#1087;&#1088;&#1080;&#1084;&#1077;&#1085;&#1080;&#1084;&#1099;&#1084; &#1079;&#1072;&#1082;&#1086;&#1085;&#1086;&#1076;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;&#1086;&#1084; &#1074; &#1088;&#1072;&#1084;&#1082;&#1072;&#1093; &#1091;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1085;&#1086;&#1081; &#1079;&#1072;&#1082;&#1086;&#1085;&#1086;&#1076;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;&#1086;&#1084; &#1087;&#1088;&#1086;&#1094;&#1077;&#1076;&#1091;&#1088;&#1099;;</span></h2>
                                                        </li>
                                                        <li class="c23 c18">
                                                            <h2 id="h.hb22ut4j6n9a" style="display:inline"><span class="c2">&#1077;&#1089;&#1083;&#1080; &#1090;&#1072;&#1082;&#1072;&#1103; &#1087;&#1077;&#1088;&#1077;&#1076;&#1072;&#1095;&#1072; &#1087;&#1088;&#1086;&#1080;&#1089;&#1093;&#1086;&#1076;&#1080;&#1090; &#1074; &#1088;&#1072;&#1084;&#1082;&#1072;&#1093; &#1087;&#1088;&#1086;&#1076;&#1072;&#1078;&#1080; &#1080;&#1083;&#1080; &#1080;&#1085;&#1086;&#1081; &#1087;&#1077;&#1088;&#1077;&#1076;&#1072;&#1095;&#1080; &#1073;&#1080;&#1079;&#1085;&#1077;&#1089;&#1072; (&#1087;&#1086;&#1083;&#1085;&#1086;&#1089;&#1090;&#1100;&#1102; &#1080;&#1083;&#1080; &#1074; &#1095;&#1072;&#1089;&#1090;&#1080;), &#1087;&#1088;&#1080; &#1101;&#1090;&#1086;&#1084; &#1082; &#1087;&#1088;&#1080;&#1086;&#1073;&#1088;&#1077;&#1090;&#1072;&#1090;&#1077;&#1083;&#1102; &#1087;&#1077;&#1088;&#1077;&#1093;&#1086;&#1076;&#1103;&#1090; &#1074;&#1089;&#1077; &#1086;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;&#1072; &#1087;&#1086; &#1089;&#1086;&#1073;&#1083;&#1102;&#1076;&#1077;&#1085;&#1080;&#1102; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1081; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1081; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1080; &#1087;&#1088;&#1080;&#1084;&#1077;&#1085;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086; &#1082; &#1087;&#1086;&#1083;&#1091;&#1095;&#1077;&#1085;&#1085;&#1086;&#1081; &#1080;&#1084; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080;;</span></h2>
                                                        </li>
                                                        <li class="c15 c18"><span>&#1074;</span><span class="c2">&nbsp;&#1094;&#1077;&#1083;&#1103;&#1093; &#1086;&#1073;&#1077;&#1089;&#1087;&#1077;&#1095;&#1077;&#1085;&#1080;&#1103; &#1074;&#1086;&#1079;&#1084;&#1086;&#1078;&#1085;&#1086;&#1089;&#1090;&#1080; &#1079;&#1072;&#1097;&#1080;&#1090;&#1099; &#1087;&#1088;&#1072;&#1074; &#1080; &#1079;&#1072;&#1082;&#1086;&#1085;&#1085;&#1099;&#1093; &#1080;&#1085;&#1090;&#1077;&#1088;&#1077;&#1089;&#1086;&#1074; &#1057;&#1072;&#1081;&#1090;&#1072; &#1080;&#1083;&#1080; &#1090;&#1088;&#1077;&#1090;&#1100;&#1080;&#1093; &#1083;&#1080;&#1094; &#1074; &#1089;&#1083;&#1091;&#1095;&#1072;&#1103;&#1093;, &#1082;&#1086;&#1075;&#1076;&#1072; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100; &#1085;&#1072;&#1088;&#1091;&#1096;&#1072;&#1077;&#1090; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1082;&#1086;&#1077; &#1089;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1077; &#1057;&#1072;&#1081;&#1090;&#1072;, &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1091;&#1102; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1091; &#1080;&#1083;&#1080; &#1080;&#1085;&#1099;&#1077; &#1076;&#1086;&#1082;&#1091;&#1084;&#1077;&#1085;&#1090;&#1099;, &#1088;&#1077;&#1075;&#1091;&#1083;&#1080;&#1088;&#1091;&#1102;&#1097;&#1080;&#1077; &#1076;&#1077;&#1103;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086;&#1089;&#1090;&#1100; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072;.</span></li>
                                                        <li
                                                            class="c15 c18"><span class="c2">&#1074; &#1088;&#1077;&#1079;&#1091;&#1083;&#1100;&#1090;&#1072;&#1090;&#1077; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1080; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103; &#1087;&#1091;&#1090;&#1077;&#1084; &#1077;&#1077; &#1086;&#1073;&#1077;&#1079;&#1083;&#1080;&#1095;&#1080;&#1074;&#1072;&#1085;&#1080;&#1103;, &#1082;&#1086;&#1075;&#1076;&#1072; &#1087;&#1086;&#1083;&#1091;&#1095;&#1077;&#1085;&#1099; &#1086;&#1073;&#1077;&#1079;&#1083;&#1080;&#1095;&#1077;&#1085;&#1085;&#1099;&#1077; &#1089;&#1090;&#1072;&#1090;&#1080;&#1089;&#1090;&#1080;&#1095;&#1077;&#1089;&#1082;&#1080;&#1077; &#1076;&#1072;&#1085;&#1085;&#1099;&#1077;, &#1082;&#1086;&#1090;&#1086;&#1088;&#1099;&#1077; &#1087;&#1077;&#1088;&#1077;&#1076;&#1072;&#1102;&#1090;&#1089;&#1103; &#1090;&#1088;&#1077;&#1090;&#1100;&#1077;&#1084;&#1091; &#1083;&#1080;&#1094;&#1091; &#1076;&#1083;&#1103; &#1087;&#1088;&#1086;&#1074;&#1077;&#1076;&#1077;&#1085;&#1080;&#1103; &#1080;&#1089;&#1089;&#1083;&#1077;&#1076;&#1086;&#1074;&#1072;&#1085;&#1080;&#1081;, &#1074;&#1099;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1088;&#1072;&#1073;&#1086;&#1090; &#1080;&#1083;&#1080; &#1086;&#1082;&#1072;&#1079;&#1072;&#1085;&#1080;&#1103; &#1091;&#1089;&#1083;&#1091;&#1075; &#1087;&#1086; &#1087;&#1086;&#1088;&#1091;&#1095;&#1077;&#1085;&#1080;&#1102; &#1057;&#1072;&#1081;&#1090;&#1072;.</span></li>
                                                    </ol>
                                                    <p class="c12"><span class="c2"></span></p>
                                                    <p class="c17"><span class="c21">5. &#1048;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1077; &#1080; &#1091;&#1076;&#1072;&#1083;&#1077;&#1085;&#1080;&#1077; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080;. </span></p>
                                                    <p
                                                        class="c17"><span class="c21">&#1054;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086;&#1077; &#1093;&#1088;&#1072;&#1085;&#1077;&#1085;&#1080;&#1077; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;</span></p>
                                                        <p
                                                            class="c13"><span class="c3">&nbsp;</span></p>
                                                            <ol class="c10 lst-kix_j63ler45idng-0 start" start="1">
                                                                <li class="c7"><span class="c2">&#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100; &#1084;&#1086;&#1078;&#1077;&#1090; &#1074; &#1083;&#1102;&#1073;&#1086;&#1081; &#1084;&#1086;&#1084;&#1077;&#1085;&#1090; &#1080;&#1079;&#1084;&#1077;&#1085;&#1080;&#1090;&#1100; (&#1086;&#1073;&#1085;&#1086;&#1074;&#1080;&#1090;&#1100;, &#1076;&#1086;&#1087;&#1086;&#1083;&#1085;&#1080;&#1090;&#1100;) &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1085;&#1091;&#1102; &#1080;&#1084; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1091;&#1102; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1102; &#1080;&#1083;&#1080; &#1077;&#1105; &#1095;&#1072;&#1089;&#1090;&#1100;, &#1072; &#1090;&#1072;&#1082;&#1078;&#1077; &#1087;&#1086;&#1090;&#1088;&#1077;&#1073;&#1086;&#1074;&#1072;&#1090;&#1100; &#1091;&#1076;&#1072;&#1083;&#1077;&#1085;&#1080;&#1103; &#1074;&#1089;&#1103;&#1082;&#1086;&#1081; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080; &#1086; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;, &#1086;&#1073;&#1088;&#1072;&#1090;&#1080;&#1074;&#1096;&#1080;&#1089;&#1100; &#1082; &#1057;&#1072;&#1081;&#1090;&#1091; &#1087;&#1086; &#1082;&#1086;&#1085;&#1090;&#1072;&#1082;&#1090;&#1072;&#1084; &#1074; &#1088;&#1072;&#1079;&#1076;&#1077;&#1083;&#1077; 9. &laquo;&#1050;&#1086;&#1085;&#1090;&#1072;&#1082;&#1090;&#1099;&raquo;.</span></li>
                                                                <li
                                                                    class="c7"><span class="c2">&#1055;&#1088;&#1072;&#1074;&#1072;, &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1085;&#1099;&#1077; &#1087;. 5.1. &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1081; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1080; &#1084;&#1086;&#1075;&#1091;&#1090; &#1073;&#1099;&#1090;&#1100; &#1086;&#1075;&#1088;&#1072;&#1085;&#1080;&#1095;&#1077;&#1085;&#1099; &#1074; &#1089;&#1086;&#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1080;&#1080; &#1089; &#1090;&#1088;&#1077;&#1073;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103;&#1084;&#1080; &#1079;&#1072;&#1082;&#1086;&#1085;&#1086;&#1076;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;&#1072;. &#1053;&#1072;&#1087;&#1088;&#1080;&#1084;&#1077;&#1088;, &#1090;&#1072;&#1082;&#1080;&#1077; &#1086;&#1075;&#1088;&#1072;&#1085;&#1080;&#1095;&#1077;&#1085;&#1080;&#1103; &#1084;&#1086;&#1075;&#1091;&#1090; &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1072;&#1090;&#1088;&#1080;&#1074;&#1072;&#1090;&#1100; &#1086;&#1073;&#1103;&#1079;&#1072;&#1085;&#1085;&#1086;&#1089;&#1090;&#1100; &#1057;&#1072;&#1081;&#1090;&#1072; &#1089;&#1086;&#1093;&#1088;&#1072;&#1085;&#1080;&#1090;&#1100; &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1085;&#1091;&#1102; &#1080;&#1083;&#1080; &#1091;&#1076;&#1072;&#1083;&#1077;&#1085;&#1085;&#1091;&#1102; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1084; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1102; &#1085;&#1072; &#1089;&#1088;&#1086;&#1082;, &#1091;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1085;&#1099;&#1081; &#1079;&#1072;&#1082;&#1086;&#1085;&#1086;&#1076;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;&#1086;&#1084;, &#1080; &#1087;&#1077;&#1088;&#1077;&#1076;&#1072;&#1090;&#1100; &#1090;&#1072;&#1082;&#1091;&#1102; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1102; &#1074; &#1089;&#1086;&#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1080;&#1080; &#1089; &#1079;&#1072;&#1082;&#1086;&#1085;&#1086;&#1076;&#1072;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086; &#1091;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1085;&#1086;&#1081; &#1087;&#1088;&#1086;&#1094;&#1077;&#1076;&#1091;&#1088;&#1086;&#1081; &#1075;&#1086;&#1089;&#1091;&#1076;&#1072;&#1088;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1086;&#1084;&#1091; &#1086;&#1088;&#1075;&#1072;&#1085;&#1091;.</span></li>
                                                            </ol>
                                                            <p class="c15"><span class="c2">&nbsp;</span></p>
                                                            <p class="c12"><span class="c2"></span></p>
                                                            <p class="c17"><span class="c27">6. </span><span class="c21">&#1048;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1077; &#1090;&#1077;&#1093;&#1085;&#1086;&#1083;&#1086;&#1075;&#1080;&#1081; &#1072;&#1074;&#1090;&#1086;&#1084;&#1072;&#1090;&#1080;&#1079;&#1080;&#1088;&#1086;&#1074;&#1072;&#1085;&#1085;&#1086;&#1081; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1080; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080;</span></p>
                                                            <p
                                                                class="c15"><span class="c3">&nbsp;</span></p>
                                                                <ol class="c10 lst-kix_2uqf52luwlch-0 start" start="1">
                                                                    <li class="c7"><span class="c19">&#1042; &#1094;&#1077;&#1083;&#1103;&#1093; </span><span class="c2">&#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1102; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1080;&#1079;&#1080;&#1088;&#1086;&#1074;&#1072;&#1085;&#1085;&#1099;&#1093; &#1089;&#1077;&#1088;&#1074;&#1080;&#1089;&#1086;&#1074;, &#1074; &#1089;&#1090;&#1072;&#1090;&#1080;&#1089;&#1090;&#1080;&#1095;&#1077;&#1089;&#1082;&#1080;&#1093; &#1080; &#1080;&#1089;&#1089;&#1083;&#1077;&#1076;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1082;&#1080;&#1093; &#1094;&#1077;&#1083;&#1103;&#1093;, &#1072; &#1090;&#1072;&#1082;&#1078;&#1077; &#1076;&#1083;&#1103; &#1091;&#1083;&#1091;&#1095;&#1096;&#1077;&#1085;&#1080;&#1103; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1099; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1084;&#1086;&#1078;&#1077;&#1090; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1100; &#1090;&#1077;&#1093;&#1085;&#1086;&#1083;&#1086;&#1075;&#1080;&#1080; &#1072;&#1074;&#1090;&#1086;&#1084;&#1072;&#1090;&#1080;&#1079;&#1080;&#1088;&#1086;&#1074;&#1072;&#1085;&#1085;&#1086;&#1081; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1080; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080;, &#1074;&#1082;&#1083;&#1102;&#1095;&#1072;&#1103;, &#1085;&#1086; &#1085;&#1077; &#1086;&#1075;&#1088;&#1072;&#1085;&#1080;&#1095;&#1080;&#1074;&#1072;&#1103;&#1089;&#1100; &#1090;&#1077;&#1093;&#1085;&#1086;&#1083;&#1086;&#1075;&#1080;&#1103;&#1084;&#1080; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1080; local storage &#1080; &#1092;&#1072;&#1081;&#1083;&#1086;&#1074; cookie.</span></li>
                                                                    <li
                                                                        class="c7"><span class="c2">&#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100; &#1086;&#1089;&#1086;&#1079;&#1085;&#1072;&#1077;&#1090;, &#1095;&#1090;&#1086; &#1086;&#1073;&#1086;&#1088;&#1091;&#1076;&#1086;&#1074;&#1072;&#1085;&#1080;&#1077; &#1080; &#1087;&#1088;&#1086;&#1075;&#1088;&#1072;&#1084;&#1084;&#1085;&#1086;&#1077; &#1086;&#1073;&#1077;&#1089;&#1087;&#1077;&#1095;&#1077;&#1085;&#1080;&#1077; (&#1074;&#1077;&#1073;-&#1073;&#1088;&#1072;&#1091;&#1079;&#1077;&#1088;), &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1091;&#1077;&#1084;&#1099;&#1077; &#1080;&#1084; &#1076;&#1083;&#1103; &#1087;&#1086;&#1089;&#1077;&#1097;&#1077;&#1085;&#1080;&#1103; &#1089;&#1072;&#1081;&#1090;&#1086;&#1074; &#1074; &#1089;&#1077;&#1090;&#1080; &#1080;&#1085;&#1090;&#1077;&#1088;&#1085;&#1077;&#1090; &#1084;&#1086;&#1075;&#1091;&#1090; &#1086;&#1073;&#1083;&#1072;&#1076;&#1072;&#1090;&#1100; &#1092;&#1091;&#1085;&#1082;&#1094;&#1080;&#1103;&#1084;&#1080; &#1079;&#1072;&#1087;&#1088;&#1077;&#1097;&#1077;&#1085;&#1080;&#1103; &#1086;&#1087;&#1077;&#1088;&#1072;&#1094;&#1080;&#1081; &#1087;&#1086; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1102; &#1083;&#1086;&#1082;&#1072;&#1083;&#1100;&#1085;&#1086;&#1075;&#1086; &#1093;&#1088;&#1072;&#1085;&#1080;&#1083;&#1080;&#1097;&#1072;, &#1086;&#1087;&#1077;&#1088;&#1072;&#1094;&#1080;&#1081; &#1089; &#1092;&#1072;&#1081;&#1083;&#1072;&#1084;&#1080; cookie, &#1072; &#1090;&#1072;&#1082;&#1078;&#1077; &#1091;&#1076;&#1072;&#1083;&#1077;&#1085;&#1080;&#1103; &#1088;&#1072;&#1085;&#1077;&#1077; &#1087;&#1086;&#1083;&#1091;&#1095;&#1077;&#1085;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;.</span></li>
                                                                        <li
                                                                            class="c7"><span class="c2">&#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1074;&#1087;&#1088;&#1072;&#1074;&#1077; &#1091;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1080;&#1090;&#1100;, &#1095;&#1090;&#1086; &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1080;&#1077; &#1086;&#1087;&#1088;&#1077;&#1076;&#1077;&#1083;&#1077;&#1085;&#1085;&#1086;&#1075;&#1086; &#1089;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; &#1080;&#1083;&#1080; &#1091;&#1089;&#1083;&#1091;&#1075;&#1080; &#1074;&#1086;&#1079;&#1084;&#1086;&#1078;&#1085;&#1086; &#1090;&#1086;&#1083;&#1100;&#1082;&#1086; &#1087;&#1088;&#1080; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1080;, &#1095;&#1090;&#1086; &#1087;&#1088;&#1080;&#1077;&#1084; &#1080; &#1087;&#1086;&#1083;&#1091;&#1095;&#1077;&#1085;&#1080;&#1077; &#1092;&#1072;&#1081;&#1083;&#1086;&#1074; cookie &#1088;&#1072;&#1079;&#1088;&#1077;&#1096;&#1077;&#1085;&#1099; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1084;.</span></li>
                                                                            <li
                                                                                class="c7"><span class="c2">&#1057;&#1090;&#1088;&#1091;&#1082;&#1090;&#1091;&#1088;&#1072; &#1092;&#1072;&#1081;&#1083;&#1072; cookie, &#1077;&#1075;&#1086; &#1089;&#1086;&#1076;&#1077;&#1088;&#1078;&#1072;&#1085;&#1080;&#1077; &#1080; &#1090;&#1077;&#1093;&#1085;&#1080;&#1095;&#1077;&#1089;&#1082;&#1080;&#1077; &#1087;&#1072;&#1088;&#1072;&#1084;&#1077;&#1090;&#1088;&#1099; &#1086;&#1087;&#1088;&#1077;&#1076;&#1077;&#1083;&#1103;&#1102;&#1090;&#1089;&#1103; &#1057;&#1072;&#1081;&#1090;&#1086;&#1084; &#1080; &#1084;&#1086;&#1075;&#1091;&#1090; &#1080;&#1079;&#1084;&#1077;&#1085;&#1103;&#1090;&#1100;&#1089;&#1103; &#1073;&#1077;&#1079; &#1087;&#1088;&#1077;&#1076;&#1074;&#1072;&#1088;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086;&#1075;&#1086; &#1091;&#1074;&#1077;&#1076;&#1086;&#1084;&#1083;&#1077;&#1085;&#1080;&#1103; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103;.</span></li>
                                                                                <li
                                                                                    class="c7"><span class="c19">&#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100; &#1086;&#1089;&#1086;&#1079;&#1085;&#1072;&#1077;&#1090;, &#1095;&#1090;&#1086; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1091;&#1077;&#1084;&#1099;&#1077; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1086;&#1084; &#1076;&#1072;&#1085;&#1085;&#1099;&#1077; &#1083;&#1086;&#1082;&#1072;&#1083;&#1100;&#1085;&#1086;&#1075;&#1086; &#1093;&#1088;&#1072;&#1085;&#1080;&#1083;&#1080;&#1097;&#1072; &#1093;&#1088;&#1072;&#1085;&#1103;&#1090;&#1089;&#1103; &#1080;&#1089;&#1082;&#1083;&#1102;&#1095;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086; &#1074; </span>
                                                                                    <span
                                                                                        class="c33">&#1082;&#1101;&#1096;&#1077; &#1074;&#1077;&#1073;-&#1073;&#1088;&#1072;&#1091;&#1079;&#1077;&#1088;&#1072; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103;
                                                                                        &#1087;&#1086;&#1089;&#1083;&#1077; &#1074;&#1093;&#1086;&#1076;&#1072; &#1074; &#1089;&#1080;&#1089;&#1090;&#1077;&#1084;&#1091;, &#1085;&#1077; &#1091;&#1076;&#1072;&#1083;&#1103;&#1102;&#1090;&#1089;&#1103;
                                                                                        &#1087;&#1086;&#1089;&#1083;&#1077; &#1079;&#1072;&#1082;&#1088;&#1099;&#1090;&#1080;&#1103; &#1086;&#1082;&#1085;&#1072; &#1074;&#1077;&#1073;-&#1073;&#1088;&#1072;&#1091;&#1079;&#1077;&#1088;&#1072;
                                                                                        (&#1077;&#1089;&#1083;&#1080; &#1074;&#1099; &#1085;&#1077; &#1091;&#1076;&#1072;&#1083;&#1080;&#1090;&#1077; &#1082;&#1101;&#1096;) &#1080; &#1084;&#1086;&#1075;&#1091;&#1090;
                                                                                        &#1073;&#1099;&#1090;&#1100; &#1079;&#1072;&#1075;&#1088;&#1091;&#1078;&#1077;&#1085;&#1099; &#1074; &#1089;&#1083;&#1077;&#1076;&#1091;&#1102;&#1097;&#1080;&#1081;
                                                                                        &#1088;&#1072;&#1079; &#1087;&#1088;&#1080; &#1087;&#1086;&#1089;&#1077;&#1097;&#1077;&#1085;&#1080;&#1080; &#1074;&#1072;&#1084;&#1080; &#1074;&#1077;&#1073;-&#1089;&#1072;&#1081;&#1090;&#1072;.
                                                                                        &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100; &#1074;&#1087;&#1088;&#1072;&#1074;&#1077; &#1086;&#1075;&#1088;&#1072;&#1085;&#1080;&#1095;&#1080;&#1090;&#1100;
                                                                                        &#1076;&#1086;&#1089;&#1090;&#1091;&#1087; &#1080;&#1083;&#1080; &#1091;&#1076;&#1072;&#1083;&#1080;&#1090;&#1100; &#1091;&#1082;&#1072;&#1079;&#1072;&#1085;&#1085;&#1099;&#1077;
                                                                                        &#1076;&#1072;&#1085;&#1085;&#1099;&#1077; &#1089;&#1072;&#1084;&#1086;&#1089;&#1090;&#1086;&#1103;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086; &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1085;&#1086;
                                                                                        &#1087;. 6.2. &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1080;.</span>
                                                                                        </li>
                                                                </ol>
                                                                <p class="c15"><span class="c2">&nbsp;</span></p>
                                                                <p class="c12"><span class="c2"></span></p>
                                                                <p class="c17"><span class="c21">7. &#1047;&#1072;&#1097;&#1080;&#1090;&#1072; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103;</span></p>
                                                                <p
                                                                    class="c13"><span class="c3">&nbsp;</span></p>
                                                                    <ol class="c10 lst-kix_b10urs79we04-0 start" start="1">
                                                                        <li class="c9 c25 c24"><span class="c2">&#1057;&#1072;&#1081;&#1090; &#1087;&#1088;&#1077;&#1076;&#1087;&#1088;&#1080;&#1085;&#1080;&#1084;&#1072;&#1077;&#1090; &#1085;&#1077;&#1086;&#1073;&#1093;&#1086;&#1076;&#1080;&#1084;&#1099;&#1077; &#1080; &#1076;&#1086;&#1089;&#1090;&#1072;&#1090;&#1086;&#1095;&#1085;&#1099;&#1077; &#1086;&#1088;&#1075;&#1072;&#1085;&#1080;&#1079;&#1072;&#1094;&#1080;&#1086;&#1085;&#1085;&#1099;&#1077; &#1080; &#1090;&#1077;&#1093;&#1085;&#1080;&#1095;&#1077;&#1089;&#1082;&#1080;&#1077; &#1084;&#1077;&#1088;&#1099; &#1076;&#1083;&#1103; &#1079;&#1072;&#1097;&#1080;&#1090;&#1099; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1103; &#1086;&#1090; &#1085;&#1077;&#1087;&#1088;&#1072;&#1074;&#1086;&#1084;&#1077;&#1088;&#1085;&#1086;&#1075;&#1086; &#1080;&#1083;&#1080; &#1089;&#1083;&#1091;&#1095;&#1072;&#1081;&#1085;&#1086;&#1075;&#1086; &#1076;&#1086;&#1089;&#1090;&#1091;&#1087;&#1072;, &#1091;&#1085;&#1080;&#1095;&#1090;&#1086;&#1078;&#1077;&#1085;&#1080;&#1103;, &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1103;, &#1073;&#1083;&#1086;&#1082;&#1080;&#1088;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103;, &#1082;&#1086;&#1087;&#1080;&#1088;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103;, &#1088;&#1072;&#1089;&#1087;&#1088;&#1086;&#1089;&#1090;&#1088;&#1072;&#1085;&#1077;&#1085;&#1080;&#1103;, &#1072; &#1090;&#1072;&#1082;&#1078;&#1077; &#1086;&#1090; &#1080;&#1085;&#1099;&#1093; &#1085;&#1077;&#1087;&#1088;&#1072;&#1074;&#1086;&#1084;&#1077;&#1088;&#1085;&#1099;&#1093; &#1076;&#1077;&#1081;&#1089;&#1090;&#1074;&#1080;&#1081; &#1089; &#1085;&#1077;&#1081; &#1090;&#1088;&#1077;&#1090;&#1100;&#1080;&#1093; &#1083;&#1080;&#1094;.</span></li>
                                                                    </ol>
                                                                    <p class="c20"><span class="c21">8. &#1048;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1077; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1080; &#1082;&#1086;&#1085;&#1092;&#1080;&#1076;&#1077;&#1085;&#1094;&#1080;&#1072;&#1083;&#1100;&#1085;&#1086;&#1089;&#1090;&#1080;</span></p>
                                                                    <ol
                                                                        class="c10 lst-kix_8svwjcre89oj-0 start" start="1">
                                                                        <li class="c7"><span class="c2">&#1057;&#1072;&#1081;&#1090; &#1080;&#1084;&#1077;&#1077;&#1090; &#1087;&#1088;&#1072;&#1074;&#1086; &#1074;&#1085;&#1086;&#1089;&#1080;&#1090;&#1100; &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1103; &#1074; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1091;&#1102; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1091; &#1082;&#1086;&#1085;&#1092;&#1080;&#1076;&#1077;&#1085;&#1094;&#1080;&#1072;&#1083;&#1100;&#1085;&#1086;&#1089;&#1090;&#1080;. &#1055;&#1088;&#1080; &#1074;&#1085;&#1077;&#1089;&#1077;&#1085;&#1080;&#1080; &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1081; &#1074; &#1072;&#1082;&#1090;&#1091;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1088;&#1077;&#1076;&#1072;&#1082;&#1094;&#1080;&#1080; &#1091;&#1082;&#1072;&#1079;&#1099;&#1074;&#1072;&#1077;&#1090;&#1089;&#1103; &#1076;&#1072;&#1090;&#1072; &#1087;&#1086;&#1089;&#1083;&#1077;&#1076;&#1085;&#1077;&#1075;&#1086; &#1086;&#1073;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103;. &#1053;&#1086;&#1074;&#1072;&#1103; &#1088;&#1077;&#1076;&#1072;&#1082;&#1094;&#1080;&#1103; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1080; &#1074;&#1089;&#1090;&#1091;&#1087;&#1072;&#1077;&#1090; &#1074; &#1089;&#1080;&#1083;&#1091; &#1089; &#1084;&#1086;&#1084;&#1077;&#1085;&#1090;&#1072; &#1077;&#1077; &#1088;&#1072;&#1079;&#1084;&#1077;&#1097;&#1077;&#1085;&#1080;&#1103;, &#1077;&#1089;&#1083;&#1080; &#1080;&#1085;&#1086;&#1077; &#1085;&#1077; &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1086; &#1085;&#1086;&#1074;&#1086;&#1081; &#1088;&#1077;&#1076;&#1072;&#1082;&#1094;&#1080;&#1077;&#1081; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1080;. &#1044;&#1077;&#1081;&#1089;&#1090;&#1074;&#1091;&#1102;&#1097;&#1072;&#1103; &#1088;&#1077;&#1076;&#1072;&#1082;&#1094;&#1080;&#1103; &#1087;&#1086;&#1089;&#1090;&#1086;&#1103;&#1085;&#1085;&#1086; &#1076;&#1086;&#1089;&#1090;&#1091;&#1087;&#1085;&#1072; &#1085;&#1072; &#1089;&#1090;&#1088;&#1072;&#1085;&#1080;&#1094;&#1077; &#1087;&#1086; &#1072;&#1076;&#1088;&#1077;&#1089;&#1091;: https://any.market/legal.</span></li>
                                                                        </ol>
                                                                        <p class="c15"><span class="c2">&nbsp;</span></p>
                                                                        <p class="c17"><span class="c21">9. &#1050;&#1086;&#1085;&#1090;&#1072;&#1082;&#1090;&#1099; &#1080; &#1074;&#1086;&#1087;&#1088;&#1086;&#1089;&#1099; &#1087;&#1086; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1084; &#1076;&#1072;&#1085;&#1085;&#1099;&#1084;</span></p>
                                                                        <p
                                                                            class="c15"><span class="c2">&nbsp;</span></p>
                                                                            <ol class="c10 lst-kix_il2ghw7mpzg3-0 start" start="1">
                                                                                <li class="c7"><span class="c2">&#1042;&#1089;&#1077; &#1087;&#1088;&#1077;&#1076;&#1083;&#1086;&#1078;&#1077;&#1085;&#1080;&#1103;, &#1074;&#1086;&#1087;&#1088;&#1086;&#1089;&#1099;, &#1079;&#1072;&#1087;&#1088;&#1086;&#1089;&#1099; &#1080; &#1080;&#1085;&#1099;&#1077; &#1086;&#1073;&#1088;&#1072;&#1097;&#1077;&#1085;&#1080;&#1103; &#1087;&#1086; &#1087;&#1086;&#1074;&#1086;&#1076;&#1091; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1081; &#1055;&#1086;&#1083;&#1080;&#1090;&#1080;&#1082;&#1080; &#1080; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1089;&#1074;&#1086;&#1080;&#1093; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100; &#1074;&#1087;&#1088;&#1072;&#1074;&#1077; &#1085;&#1072;&#1087;&#1088;&#1072;&#1074;&#1083;&#1103;&#1090;&#1100; &#1057;&#1072;&#1081;&#1090;&#1091;:</span></li>
                                                                            </ol>
                                                                            <ol class="c10 lst-kix_il2ghw7mpzg3-1 start" start="1">
                                                                                <li class="c15 c22"><span class="c2">&#1087;&#1086; &#1072;&#1076;&#1088;&#1077;&#1089;&#1091; &#1101;&#1083;&#1077;&#1082;&#1090;&#1088;&#1086;&#1085;&#1085;&#1086;&#1081; &#1087;&#1086;&#1095;&#1090;&#1099;: info@any.market</span></li>
                                                                                <li
                                                                                    class="c15 c22"><span class="c2">&#1087;&#1086; &#1087;&#1086;&#1095;&#1090;&#1086;&#1074;&#1086;&#1084;&#1091; &#1072;&#1076;&#1088;&#1077;&#1089;&#1091;: 344011 &#1075;. &#1056;&#1086;&#1089;&#1090;&#1086;&#1074;-&#1085;&#1072;-&#1044;&#1086;&#1085;&#1091;, &#1091;&#1083;. &#1050;&#1072;&#1090;&#1072;&#1077;&#1074;&#1072;, &#1076;. 259 &#1082;&#1074;. 3</span></li>
                                                                            </ol>
                                                                            <p class="c15 c24"><span class="c2">&nbsp;</span></p>
                                                                            <p class="c9"><span class="c2">&#1044;&#1072;&#1090;&#1072; &#1087;&#1091;&#1073;&#1083;&#1080;&#1082;&#1072;&#1094;&#1080;&#1080; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1081; &#1088;&#1077;&#1076;&#1072;&#1082;&#1094;&#1080;&#1080;: 20.10.2020 &#1075;.</span></p>
                                                                            <p
                                                                                class="c15"><span class="c2">&nbsp;</span></p>
                                                                                <p class="c1"><span class="c2">&nbsp;</span></p>
                                                                                <p class="c4"><span class="c2"></span></p>
                                                                                <p class="c4"><span class="c2"></span></p>
                                                                                <p class="c4"><span class="c2"></span></p>
                                                                                <p class="c4"><span class="c2"></span></p>
</body>

</html>
`;
